<template>
    <div>
        <v-container fluid class="pb-0">
            <v-row no-gutters>
                <v-col>
                    <h1 class="headline font-weight-light">
                        HAPPY CALL
                        <v-btn
                            v-if="
                                (this.selectproject != '' &&
                                    this.adminstatus == 'Programmer') ||
                                    this.adminstatus == 'Manager'
                            "
                            class="ml-3"
                            color="teal lighten-1"
                            @click="viewallbooking()"
                            elevation="0"
                            small
                            rounded
                            dark
                        >
                            <v-icon x-small class="mr-3"
                                >mdi-book-plus-multiple</v-icon
                            >
                            Booking & Happy Call Today
                        </v-btn>

                        <v-btn
                            v-if="
                                this.selectproject != '' &&
                                    (this.adminstatus == 'Programmer' ||
                                        this.adminstatus == 'Manager')
                            "
                            class="ml-3"
                            color="primary"
                            @click="viewallpending()"
                            elevation="0"
                            small
                            rounded
                            dark
                        >
                            <v-icon x-small class="mr-3">mdi-share-all</v-icon>
                            Pass Case to Close Case
                        </v-btn>
                    </h1>
                </v-col>
            </v-row>

            <v-row>
                <v-col md="3" sm="4" cols="12" v-if="selectproject != 'BENCH'">
                    <v-card
                        v-if="statustab == true"
                        @click="getProject('all')"
                        :class="
                            selectprojectsub === 'all'
                                ? 'mx-auto red '
                                : 'mx-auto'
                        "
                        filled
                    >
                        <v-card-text>
                            <h2
                                style="text-align: center"
                                :class="
                                    selectprojectsub === 'all' ? 'fontglow' : ''
                                "
                            >
                                All
                            </h2>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    md="3"
                    sm="4"
                    cols="12"
                    v-if="statustab == true"
                    v-for="(item1, idx1) in data.summary"
                    :key="idx1"
                >
                    <v-card
                        @click="
                            getProject(
                                data.summary[idx1].show_name,
                                data.happycall_team,
                                data.summary[idx1].project_id
                            )
                        "
                        :class="
                            selectprojectsub === data.summary[idx1].show_name
                                ? 'mx-auto red'
                                : 'mx-auto'
                        "
                        filled
                    >
                        <v-card-text>
                            <h2
                                style="text-align: center"
                                :class="
                                    selectprojectsub ===
                                    data.summary[idx1].show_name
                                        ? 'fontglow'
                                        : ''
                                "
                            >
                                {{ item1.show_name }}
                            </h2>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-progress-linear
                    v-else-if="statustab == false"
                    indeterminate
                    color="cyan"
                ></v-progress-linear>
            </v-row>
        </v-container>

        <v-row>
            <v-dialog
                v-model="dialogbooking"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-app-bar fixed dense dark color="primary">
                        <v-btn icon dark @click="dialogbooking = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                            >Booking & Happy Call Today</v-toolbar-title
                        >

                        <v-spacer> </v-spacer>

                        <v-toolbar-items>
                            <v-btn dark text @click="saveallbooking()"
                                >RETURN CASE TO PENDING</v-btn
                            >
                        </v-toolbar-items>
                    </v-app-bar>
                    <v-card-title style="margin-top: 30px">
                        <!-- <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
            ></v-text-field> -->
                        <v-spacer></v-spacer>
                    </v-card-title>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-toolbar-title>
                                <v-icon>mdi-notebook-outline</v-icon> Booking
                                <v-chip small>
                                    <strong>{{
                                        this.databooking.length
                                    }}</strong>
                                </v-chip>
                            </v-toolbar-title>

                            <v-row>
                                <v-col>
                                    <v-btn
                                        @click="
                                            selectallbooking == true
                                                ? (selectallbooking = false)
                                                : (selectallbooking = true),
                                                btnselectallbooking()
                                        "
                                        :class="
                                            selectallbooking == true
                                                ? 'primary'
                                                : ''
                                        "
                                    >
                                        <v-icon left
                                            >mdi-chevron-right-circle</v-icon
                                        >Select All
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-data-table
                                :headers="headerz"
                                :items="this.databooking"
                                :items-per-page="-1"
                                :loading="isLoading"
                                loading-text="Loading... Please wait"
                            >
                                <template v-slot:[`item.checkbox`]="{ item }">
                                    <span class="subtitle-1">
                                        {{ checkbooking }}
                                        <v-checkbox
                                            type="checkbox"
                                            :value="item.maincase_id"
                                            v-model="checkedbooking"
                                    /></span>
                                </template>
                                <template
                                    v-slot:[`item.sumtitlebooking`]="{ item }"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >{{ item.case_id }}-{{
                                                item.subcase
                                            }}</v-list-item-title
                                        >
                                        <v-list-item-subtitle
                                            >{{ item.site_name }} ({{
                                                item.customer_name
                                            }})</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                            style="font-weight: 500"
                                            >{{ item.customer_tel }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>{{
                                            item.created_date
                                        }}</v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            style="font-weight: bold"
                                            >{{
                                                item.adminname
                                            }}</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                            style="font-weight: bold"
                                            >(HPC_Date:
                                            {{
                                                item.adminInformed_date
                                            }})</v-list-item-subtitle
                                        >
                                    </v-list-item-content>
                                </template>
                            </v-data-table>
                            <!-- <v-list three-line subheader>
                <v-simple-table>
                  <template>
                    <thead>
                      <tr style="background-color:black;">
                        <th
                          class="text-center"
                          style="width:20px;border:2px black solid;color:white;"
                        >
                          #
                        </th>
                        <th
                          class="text-left"
                          style="border:2px black solid;color:white;"
                        >
                          CaseID/Detail
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(databooking, idxbooking) in databooking"
                        :key="idxbooking"
                      >
                        <td class="text-center">
                          <v-checkbox
                            type="checkbox"
                            :value="databooking.maincase_id"
                            v-model="checkedbooking"
                          />
                        </td>
                        <td class="text-left">
                          <v-list-item-content>
                            <v-list-item-title
                              >{{ databooking.case_id }}-{{
                                databooking.subcase
                              }}</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >{{ databooking.site_name }} ({{
                                databooking.customer_name
                              }})</v-list-item-subtitle
                            >
                            <v-list-item-subtitle>{{
                              databooking.created_date
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle style="font-weight:bold">{{
                              databooking.adminname
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle style="font-weight:bold"
                              >(HPC_Date:
                              {{
                                databooking.adminInformed_date
                              }})</v-list-item-subtitle
                            >
                          </v-list-item-content>
                        </td>
                      </tr>

                    <td class="text-center">
                      <v-checkbox
                        type="checkbox"
                        :value="2"
                        id="2"
                        v-model="checked"
                        @change="check($event)"
                      />
                    </td>

                    <td class="text-left">
                      <v-list-item-content>
                        <v-list-item-title>22</v-list-item-title>
                        <v-list-item-subtitle>22</v-list-item-subtitle>
                      </v-list-item-content>
                    </td>
                  </tr> -->
                            <!-- </tbody> -->
                            <!-- </template> -->
                            <!-- {{ checked }} -->
                            <!-- </v-simple-table> -->
                            <!-- </v-list> -->
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-toolbar-title>
                                <v-icon>mdi-phone-check</v-icon> HPC Today
                                <v-chip small>
                                    <strong>{{
                                        this.datahpctoday.length
                                    }}</strong>
                                </v-chip>
                            </v-toolbar-title>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        @click="
                                            selectalltoday == true
                                                ? (selectalltoday = false)
                                                : (selectalltoday = true),
                                                btnselectalltoday()
                                        "
                                        :class="
                                            selectalltoday == true
                                                ? 'primary'
                                                : ''
                                        "
                                    >
                                        <v-icon left
                                            >mdi-chevron-right-circle</v-icon
                                        >Select All
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-data-table
                                :headers="headers"
                                :items="this.datahpctoday"
                                :items-per-page="-1"
                                :loading="isLoading"
                                loading-text="Loading... Please wait"
                            >
                                <template v-slot:[`item.checkbox`]="{ item }">
                                    <span class="subtitle-1">
                                        <v-checkbox
                                            :id="item.maincase_id"
                                            type="checkbox"
                                            :value="item.maincase_id"
                                            v-model="checkedbooking"
                                    /></span>
                                </template>
                                <template
                                    v-slot:[`item.sumtitlebooking`]="{ item }"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >{{ item.case_id }}-{{
                                                item.subcase
                                            }}</v-list-item-title
                                        >
                                        <v-list-item-subtitle
                                            >{{ item.site_name }} ({{
                                                item.customer_name
                                            }})</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                            style="font-weight: 500"
                                            >{{
                                                item.customer_tel
                                            }}</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle>{{
                                            item.created_date
                                        }}</v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            style="font-weight: bold"
                                            >{{
                                                item.adminname
                                            }}</v-list-item-subtitle
                                        >
                                        <v-list-item-subtitle
                                            style="font-weight: bold"
                                            >(HPC_Date:
                                            {{
                                                item.hpc_date
                                            }})</v-list-item-subtitle
                                        >
                                    </v-list-item-content>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-app-bar fixed dense dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                            >HPC Close Case UC
                            <v-chip small>
                                <strong>{{ this.datapending.length }}</strong>
                            </v-chip>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="savependinguc()"
                                >Save</v-btn
                            >
                        </v-toolbar-items>

                        <!-- <v-row>
              <v-col sm="6" md="3">
                <h3 class="pb-2">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon color="black">mdi-close</v-icon>
                  </v-btn>
                </h3>
                <v-toolbar-title color="black"
                  >HPC Close Case UC</v-toolbar-title
                >
              </v-col>
            </v-row> -->
                    </v-app-bar>
                    <v-divider></v-divider>
                    <br />

                    <v-list three-line subheader style="margin-top: 40px">
                        <v-subheader>
                            <v-btn
                                class="ma-2"
                                text
                                icon
                                x-large
                                :rules="IconR"
                                required
                            >
                                <v-icon
                                    class="display-1"
                                    @click="
                                        buttonbad == true
                                            ? (buttonbad = false)
                                            : (buttonbad = true),
                                            checkboxselect(
                                                datapending.length,
                                                'L'
                                            )
                                    "
                                    :color="buttonbad == true ? 'red' : ''"
                                    >mdi-emoticon-sad</v-icon
                                >
                            </v-btn>

                            <v-btn
                                class="ma-2"
                                text
                                icon
                                x-large
                                :rules="IconR"
                                required
                            >
                                <v-icon
                                    darken-2
                                    class="display-1"
                                    @click="
                                        buttonnormal == true
                                            ? (buttonnormal = false)
                                            : (buttonnormal = true),
                                            checkboxselect(
                                                datapending.length,
                                                'M'
                                            )
                                    "
                                    :color="
                                        buttonnormal == true
                                            ? 'amber darken-2'
                                            : ''
                                    "
                                    >mdi-emoticon-neutral</v-icon
                                >
                            </v-btn>
                            <v-btn
                                class="ma-2"
                                text
                                icon
                                x-large
                                :rules="IconR"
                                required
                            >
                                <v-icon
                                    class="display-1"
                                    @click="
                                        buttongood == true
                                            ? (buttongood = false)
                                            : (buttongood = true),
                                            checkboxselect(
                                                datapending.length,
                                                'H'
                                            )
                                    "
                                    :color="buttongood == true ? 'green' : ''"
                                    >mdi-emoticon-excited</v-icon
                                >
                            </v-btn>
                            <v-btn
                                class="ma-2"
                                text
                                icon
                                x-large
                                :rules="IconR"
                                required
                            >
                                <v-icon
                                    class="display-1"
                                    @click="
                                        buttonphone == true
                                            ? (buttonphone = false)
                                            : (buttonphone = true),
                                            checkboxselect(
                                                datapending.length,
                                                'P'
                                            )
                                    "
                                    :color="buttonphone == true ? 'blue' : ''"
                                    >mdi-phone</v-icon
                                >
                            </v-btn>
                            <h1
                                style="
                                    padding: 5px;
                                    border: 10px solid navy;
                                    margin: 10px;
                                    border-color: blue;
                                    color: black;
                                "
                            >
                                {{ this.checked.length }}
                            </h1>
                        </v-subheader>
                        <v-row>
                            <v-col>
                                <v-btn
                                    @click="
                                        selectAllPending == true
                                            ? (selectAllPending = false)
                                            : (selectAllPending = true),
                                            btnSelectAllPending()
                                    "
                                    :class="
                                        selectAllPending == true
                                            ? 'primary'
                                            : ''
                                    "
                                >
                                    <v-icon left>mdi-chevron-right-circle</v-icon>Select All
                                </v-btn>
                            </v-col>
                        </v-row>
                        <br />
                        <v-simple-table>
                            <template>
                               <thead>
                                        <tr style="background-color: black">
                                            <th
                                                class="text-center"
                                                style="
                                                    width: 20px;
                                                    border: 2px black solid;
                                                    color: white;
                                                "
                                            >
                                                #
                                            </th>
                                            <th
                                                style="
                                                    width: 50%;
                                                    border: 2px black solid;
                                                    color: white;
                                                "
                                            >
                                                CaseID/Detail
                                            </th>
                                            <th
                                                class="text-center"
                                                style="
                                                    width: 150px;
                                                    border: 2px black solid;
                                                    color: white;
                                                "
                                            >
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                <tbody v-if="viewpendingtab == true">
                                    <tr
                                        v-for="(datapending,
                                        idxpending) in datapending"
                                        :key="idxpending"
                                    >
                                        <td class="text-center">
                                            <v-checkbox
                                                type="checkbox"
                                                :value="datapending.maincase_id"
                                                v-model="checked"
                                            />
                                        </td>
                                        <td class="text-left">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-chip
                                                        small
                                                        label
                                                        dark
                                                        class="mr-2 teal"
                                                    >
                                                        <span
                                                            class="font-weight-medium"
                                                            >{{
                                                                datapending.project_name
                                                            }}</span
                                                        > </v-chip
                                                    ><label
                                                        style="
                                                            font-weight: bold;
                                                        "
                                                        >{{
                                                            datapending.case_id
                                                        }}-{{
                                                            datapending.subcase
                                                        }}</label
                                                    >
                                                </v-list-item-title>
                                                <v-list-item-subtitle>{{
                                                    datapending.customer_name
                                                }}</v-list-item-subtitle>
                                                <v-list-item-subtitle>{{
                                                    datapending.site_name
                                                }}</v-list-item-subtitle>
                                                <v-list-item-subtitle>
                                                    <div
                                                        v-if="
                                                            datapending.case_title
                                                        "
                                                    >
                                                        <span
                                                            v-if="
                                                                datapending.case_title <
                                                                    150
                                                            "
                                                            >{{
                                                                datapending.case_title
                                                            }}</span
                                                        >
                                                        <span v-else
                                                            >{{
                                                                datapending.case_title.substring(
                                                                    0,
                                                                    75
                                                                )
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                    }"
                                                                >
                                                                    <button
                                                                        fab
                                                                        dark
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        x-small
                                                                        elevation="0"
                                                                    >
                                                                        ...
                                                                    </button>
                                                                </template>
                                                                <span>{{
                                                                    datapending.case_title
                                                                }}</span>
                                                            </v-tooltip>
                                                        </span>
                                                    </div>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    style="font-weight: bold"
                                                ></v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    style="font-weight: bold"
                                                ></v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    style="font-weight: bold"
                                                >
                                                    {{ datapending.solution }}
                                                </v-list-item-subtitle>

                                                <v-list-item-subtitle>
                                                    CE Close :
                                                    {{
                                                        datapending.ce_last_updated
                                                    }}</v-list-item-subtitle
                                                >
                                                <v-list-item-subtitle
                                                    v-if="
                                                        datapending.ce_customer_level ==
                                                            'L'
                                                    "
                                                    style="margin-left: -8px"
                                                >
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1"
                                                            color="red"
                                                            >mdi-emoticon-sad</v-icon
                                                        >
                                                    </v-btn>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-if="
                                                        datapending.ce_customer_level ==
                                                            'M'
                                                    "
                                                    style="margin-left: -8px"
                                                >
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1"
                                                            color="amber darken-2"
                                                            >mdi-emoticon-neutral</v-icon
                                                        >
                                                    </v-btn>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-if="
                                                        datapending.ce_customer_level ==
                                                            'H'
                                                    "
                                                    style="margin-left: -8px"
                                                >
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1"
                                                            color="green"
                                                            >mdi-emoticon-excited</v-icon
                                                        >
                                                    </v-btn>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-if="
                                                        datapending.sub_status_name ==
                                                            'Clear by Phone'
                                                    "
                                                    style="margin-left: -8px"
                                                >
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                    >
                                                        <v-icon
                                                            class="display-1"
                                                            color="blue"
                                                            >mdi-phone</v-icon
                                                        >
                                                    </v-btn>
                                                </v-list-item-subtitle>
                                                <!-- <v-list-item-subtitle
                          v-if="
                            datapending.ce_customer_level == null ||
                              datapending.ce_customer_level == ''
                          "
                          style="margin-left:-8px"
                        >
                          <v-btn class="ma-2" text icon>
                            <v-icon class="display-1 " color="red"
                              >mdi-cancel</v-icon
                            >
                          </v-btn>
                        </v-list-item-subtitle> -->
                                            </v-list-item-content>
                                        </td>
                                        <td class="text-center">
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-btn
                                                        color="orange"
                                                        fab
                                                        dark
                                                        v-on="on"
                                                        x-small
                                                        elevation="0"
                                                    >
                                                        <v-icon small>{{
                                                            datapending.main_status_icon
                                                        }}</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    datapending.main_status_name
                                                }}</span>
                                            </v-tooltip>
                                            <span
                                                class="ml-2 font-weight-medium"
                                                >{{
                                                    datapending.sub_status_name
                                                }}</span
                                            >

                                            <p
                                                v-if="
                                                    datapending.project_name ==
                                                        'CDAX' ||
                                                        datapending.project_name ==
                                                            'S-Print'
                                                "
                                                class="mt-2 font-weight-medium"
                                            >
                                                CDAX :
                                                {{ datapending.status_name }}
                                            </p>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                    <td class="text-center">
                      <v-checkbox
                        type="checkbox"
                        :value="2"
                        id="2"
                        v-model="checked"
                        @change="check($event)"
                      />
                    </td>

                    <td class="text-left">
                      <v-list-item-content>
                        <v-list-item-title>22</v-list-item-title>
                        <v-list-item-subtitle>22</v-list-item-subtitle>
                      </v-list-item-content>
                    </td>
                  </tr> -->
                                </tbody>
                                <tbody v-else-if="viewpendingtab == false">
                                    <tr>
                                        <td colspan="3">
                                            <v-progress-linear
                                                indeterminate
                                                color="cyan"
                                            ></v-progress-linear>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <!-- {{ checked }} -->
                        </v-simple-table>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-form method="post" id="nativeForm" v-model="valid">
            <v-container fluid v-if="selectprojectsub != ''" class="pt-0">
                <v-row v-if="selectprojectsub == 'all'">
                    <v-col :md="3" :sm="4" v-if="datasummary.Pending > 0">
                        <sum-card
                            @onClick="showdata('all', 'Pending')"
                            color="orange accent-3"
                            :icon="
                                datashowdatastatus == 'Pending'
                                    ? 'mdi-check-circle'
                                    : 'mdi-face-agent'
                            "
                            :num_data="datasummary.Pending"
                            title="Pending"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.Premium > 0">
                        <sum-card
                            @onClick="showdata('all', 'Premium')"
                            color="deep-purple darken-2"
                            :icon="
                                datashowdatastatus == 'Premium'
                                    ? 'mdi-check-circle'
                                    : 'mdi-star'
                            "
                            :num_data="datasummary.Premium"
                            title="Premium / Student"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.CannotContact > 0">
                        <sum-card
                            @onClick="showdata('all', 'Cannot Contact')"
                            color="red darken-1"
                            :icon="
                                datashowdatastatus == 'Cannot Contact'
                                    ? 'mdi-check-circle'
                                    : 'mdi-phone-off'
                            "
                            :num_data="datasummary.CannotContact"
                            title="Can't Contact"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.NoEmail > 0">
                        <sum-card
                            @onClick="showdata('all', 'No Email')"
                            color="teal lighten-1"
                            :icon="
                                datashowdatastatus == 'No Email'
                                    ? 'mdi-check-circle'
                                    : 'mdi-email-off-outline'
                            "
                            :num_data="datasummary.NoEmail"
                            title="NoEmail"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.Recontact > 0">
                        <sum-card
                            @onClick="showdata('all', 'Recontact')"
                            color="cyan lighten-1"
                            :icon="
                                datashowdatastatus == 'Recontact'
                                    ? 'mdi-check-circle'
                                    : 'mdi-phone-return'
                            "
                            :num_data="datasummary.Recontact"
                            title="Recontact"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="selectprojectsub != 'all'">
                    <v-col :md="3" :sm="4" v-if="datasummary.Pending > 0">
                        <sum-card
                            @onClick="showdata(selectprojectid, 'Pending')"
                            color="orange accent-3"
                            :icon="
                                datashowdatastatus == 'Pending'
                                    ? 'mdi-check-circle'
                                    : 'mdi-face-agent'
                            "
                            :num_data="datasummary.Pending"
                            title="Pending"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.Premium > 0">
                        <sum-card
                            @onClick="showdata('all', 'Premium')"
                            color="deep-purple darken-2"
                            :icon="
                                datashowdatastatus == 'Premium'
                                    ? 'mdi-check-circle'
                                    : 'mdi-star'
                            "
                            :num_data="datasummary.Premium"
                            title="Premium / Student"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.CannotContact > 0">
                        <sum-card
                            @onClick="
                                showdata(selectprojectid, 'Cannot Contact')
                            "
                            color="red darken-1"
                            :icon="
                                datashowdatastatus == 'Cannot Contact'
                                    ? 'mdi-check-circle'
                                    : 'mdi-phone-off'
                            "
                            :num_data="datasummary.CannotContact"
                            title="Can't Contact"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.NoEmail > 0">
                        <sum-card
                            @onClick="showdata(selectprojectid, 'No Email')"
                            color="teal lighten-1"
                            :icon="
                                datashowdatastatus == 'No Email'
                                    ? 'mdi-check-circle'
                                    : 'mdi-email-off-outline'
                            "
                            :num_data="datasummary.NoEmail"
                            title="NoEmail"
                        />
                    </v-col>
                    <v-col :md="3" :sm="4" v-if="datasummary.Recontact > 0">
                        <sum-card
                            @onClick="showdata(selectprojectid, 'Recontact')"
                            color="cyan lighten-1"
                            :icon="
                                datashowdatastatus == 'Recontact'
                                    ? 'mdi-check-circle'
                                    : 'mdi-phone-return'
                            "
                            :num_data="datasummary.Recontact"
                            title="Recontact"
                        />
                    </v-col>
                </v-row>
                <v-card>
                    <v-row>
                        <v-col
                            cols="12"
                            sm="4"
                            md="4"
                            style="margin-left: 10px"
                        >
                            <v-text-field
                                v-model="searchtext"
                                @input="
                                    showdata(
                                        projectidstatus,
                                        datashowdatastatus
                                    )
                                "
                                append-icon="mdi-magnify"
                                label="Search"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card
                    v-if="datashowdata.length > 0 && casestatus == true"
                    @keydown.esc="btnexitdialog"
                >
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th
                                        class="text-center"
                                        style="background-color: #ffe4c4"
                                    >
                                        <b style="color: black; font-size: 16px"
                                            >#</b
                                        >
                                    </th>
                                    <th style="background-color: #ffe4c4">
                                        <b style="color: black; font-size: 16px"
                                            >CaseID</b
                                        >
                                    </th>
                                    <th style="background-color: #ffe4c4">
                                        <b style="color: black; font-size: 16px"
                                            >Site Name</b
                                        >
                                    </th>

                                    <th
                                        class="text-center"
                                        style="
                                            width: 100px;
                                            background-color: #ffe4c4;
                                        "
                                    >
                                        <b style="color: black; font-size: 16px"
                                            >TAT</b
                                        >
                                        <v-icon
                                            v-if="sorttatcondition == ''"
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'tat',
                                                    'asc'
                                                )
                                            "
                                            right
                                            style="float: right"
                                            >mdi-sort</v-icon
                                        >
                                        <v-icon
                                            v-else-if="
                                                sorttatcondition == 'asc'
                                            "
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'tat',
                                                    'desc'
                                                )
                                            "
                                            right
                                            style="float: right"
                                            >mdi-sort-descending</v-icon
                                        >
                                        <v-icon
                                            v-else-if="
                                                sorttatcondition == 'desc'
                                            "
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'tat',
                                                    'asc'
                                                )
                                            "
                                            right
                                            style="float: right"
                                            >mdi-sort-ascending</v-icon
                                        >
                                    </th>
                                    <th
                                        style="
                                            width: 120px;
                                            background-color: #ffe4c4;
                                        "
                                    >
                                        <b style="color: black; font-size: 16px"
                                            >Admin</b
                                        >
                                        <v-icon
                                            v-if="sortadmincondition == ''"
                                            right
                                            style="float: right"
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'adminname',
                                                    'asc'
                                                )
                                            "
                                            >mdi-sort</v-icon
                                        >
                                        <v-icon
                                            v-else-if="
                                                sortadmincondition == 'asc'
                                            "
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'adminname',
                                                    'desc'
                                                )
                                            "
                                            right
                                            style="float: right"
                                            >mdi-sort-descending</v-icon
                                        >
                                        <v-icon
                                            v-else-if="
                                                sortadmincondition == 'desc'
                                            "
                                            @click="
                                                showdata(
                                                    projectidstatus,
                                                    datashowdatastatus,
                                                    'adminname',
                                                    'asc'
                                                )
                                            "
                                            right
                                            style="float: right"
                                            >mdi-sort-ascending</v-icon
                                        >
                                    </th>
                                    <th
                                        class="text-center"
                                        style="background-color: #ffe4c4"
                                    ></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(datashowdata,
                                    idxshowdata) in datashowdata"
                                    :key="idxshowdata"
                                >
                                    <td class="text-center">
                                        {{
                                            idxshowdata +
                                                1 +
                                                (datapage.current_page - 1) * 20
                                        }}
                                    </td>
                                    <td class="text-left">
                                        <v-badge
                                            v-if="
                                                datashowdata.bypass == 'bypass'
                                            "
                                            inline
                                            color="orange lighten-1"
                                            :content="datashowdata.num_cases"
                                        ></v-badge>
                                        <v-badge
                                            v-else
                                            inline
                                            color="blue lighten-1"
                                            :content="datashowdata.num_cases"
                                        ></v-badge>

                                        <label
                                            style="
                                                margin-left: 5px;
                                                font-weight: bold;
                                            "
                                            >{{ datashowdata.case_id }}</label
                                        >
                                        <br />
                                        <label style="">{{
                                            datashowdata.min_gps_date
                                        }}</label>
                                    </td>
                                    <td class="text-left">
                                        <label>{{
                                            datashowdata.site_name
                                        }}</label>
                                        <br />
                                        <label>
                                            <b>{{
                                                datashowdata.customer_name
                                            }}</b>
                                        </label>
                                    </td>

                                    <td
                                        class="text-center"
                                        v-if="datashowdata.tat > 5"
                                        style="color: red; font-weight: bold"
                                    >
                                        {{ datashowdata.tat }}
                                    </td>
                                    <td class="text-center" v-else>
                                        {{ datashowdata.tat }}
                                    </td>
                                    <td class="text-left">
                                        {{ datashowdata.adminname }}
                                    </td>
                                    <td class="text-center">
                                        <div class="my-2">
                                            <v-btn
                                                v-if="
                                                    adminstatus == 'Manager' ||
                                                        adminstatus ==
                                                            'Programmer' ||
                                                        (adminstatus ==
                                                            'Senior' &&
                                                            datashowdatastatus !=
                                                                'Pending' &&
                                                            datashowdatastatus !=
                                                                'No Email')
                                                "
                                                @click="
                                                    returncase(
                                                        datashowdata.case_id
                                                    )
                                                "
                                                style="
                                                    color: #edf5f7;
                                                    text-shadow: 0px 0px 10px
                                                        rgba(189, 250, 250, 0.5);
                                                "
                                                fab
                                                x-small
                                                dark
                                                class="ml-2"
                                                elevation="1"
                                            >
                                                <v-icon color="red"
                                                    >mdi-reply</v-icon
                                                >
                                            </v-btn>
                                            <v-btn
                                                @click="
                                                    showdialogdetail(
                                                        datashowdata.project_id,
                                                        datashowdatastatus,
                                                        datashowdata.site_name,
                                                        datashowdata.customer_name
                                                    )
                                                "
                                                style="
                                                    color: #edf5f7;
                                                    text-shadow: 0px 0px 10px
                                                        rgba(189, 250, 250, 0.5);
                                                "
                                                fab
                                                x-small
                                                dark
                                                class="ml-2"
                                                elevation="1"
                                            >
                                                <v-icon
                                                    >mdi-format-list-bulleted-square</v-icon
                                                >
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <div
                        class="pt-4 pb-5 text-center"
                        v-if="this.selectprojectsub == 'all'"
                    >
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark small>mdi-chevron-left</v-icon>
                            </v-btn>

                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="getall(page_num_show(n))"
                                >{{ page_num_show(n) }}</v-btn
                            >

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark small>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div class="pt-4 pb-5 text-center" v-else>
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark small>mdi-chevron-left</v-icon>
                            </v-btn>

                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="
                                    get_it_page(
                                        page_num_show(n),
                                        datashowdata[0].project_id
                                    )
                                "
                                >{{ page_num_show(n) }}</v-btn
                            >

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark small>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
                <v-progress-linear
                    v-else
                    indeterminate
                    color="cyan"
                ></v-progress-linear>
                <v-dialog
                    v-model="dialogdetail"
                    @keydown.esc="btnexitdialog"
                    persistent
                    max-width="100%;"
                >
                    <v-card>
                        <div id="happycall">
                            <v-alert
                                dense
                                border="center"
                                type="black"
                                icon="mdi-phone"
                                >ผลสำรวจ Happycall
                            </v-alert>
                            <v-card-text>
                                <v-container>
                                    <!-- <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-for="(itemdetail1, z) in datadetail"
                      :key="z"
                    >
                      <div v-if="itemdetail1.cdax_log === null"></div>
                      <div v-else>
                        <v-textarea
                          v-if="z == 0"
                          v-model="itemdetail1.cdax_log.log"
                          outlined
                          name="input-7-4"
                          label="Note Logs"
                          row-height="15"
                          rows="6"
                        ></v-textarea>
                      </div>
                    </v-col>

                     <v-col cols="12" sm="6" md="4">
                    <span class="font-weight-bold subtitle-1"
                      >ติดต่อลูกค้าได้หรือไม่</span
                    >
                    <v-radio-group v-model="row" row>
                      <v-radio label="ได้" value="Y"></v-radio>
                      <v-radio label="ไม่ได้" value="N"></v-radio>
                    </v-radio-group>
                    <span class="font-weight-bold subtitle-1">
                      ติดต่อลูกค้าได้หรือไม่
                    </span>
                    <v-radio-group v-model="row" row>
                      <v-radio label="ได้" value="Y"></v-radio>
                      <v-radio label="ไม่ได้" value="N"></v-radio>
                    </v-radio-group>
                    <v-textarea
                      outlined
                      name="input-7-4"
                      label="Remark"
                    ></v-textarea>
                  </v-col> -->
                                    <!-- </v-row> -->
                                    -->
                                </v-container>

                                <v-tabs
                                    style="margin-top: -40px"
                                    background-color="primary"
                                    color="yellow"
                                    dark
                                    v-model="tab"
                                >
                                    <v-tab
                                        v-for="(itemdetail, i) in datadetail"
                                        :key="i"
                                        @click="
                                            getDetail(itemdetail.maincase_id)
                                        "
                                        >{{ itemdetail.case_id }}-{{
                                            itemdetail.subcase
                                        }}</v-tab
                                    >
                                </v-tabs>

                                <v-tabs-items touchless v-model="tab">
                                    <v-tab-item
                                        v-for="(itemdetail, i) in datadetail"
                                        :key="i"
                                    >
                                        <v-card>
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="12" md="4">
                                                        <v-row>
                                                            <v-col
                                                                cols="6"
                                                                md="2"
                                                            >
                                                                <label
                                                                    class="caseID"
                                                                    >Case ID
                                                                    :</label
                                                                >
                                                            </v-col>
                                                            <v-col
                                                                cols="6"
                                                                md="2"
                                                                class="valuecaseID"
                                                            >
                                                                <label
                                                                    style="
                                                                        font-size: 14px;
                                                                        color: black;
                                                                    "
                                                                >
                                                                    {{
                                                                        itemdetail.case_id
                                                                    }}-{{
                                                                        itemdetail.subcase
                                                                    }}
                                                                </label>
                                                            </v-col>
                                                            <v-col
                                                                cols="6"
                                                                md="5"
                                                            >
                                                                <view-cdax
                                                                    :caseid="
                                                                        itemdetail.case_id
                                                                    "
                                                                >
                                                                </view-cdax>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col
                                                                cols="12"
                                                                md="12"
                                                            >
                                                                <v-chip
                                                                    small
                                                                    style="
                                                                        background-color: #d99a1c;
                                                                    "
                                                                    class="mb-2 mr-2 lighten-1"
                                                                >
                                                                    <label
                                                                        style="
                                                                            color: white;
                                                                        "
                                                                        >Case
                                                                        Status :
                                                                        {{
                                                                            itemdetail.main_status_name
                                                                        }}</label
                                                                    >
                                                                </v-chip>

                                                                <v-chip
                                                                    small
                                                                    class="mb-2 mr-2 lighten-1"
                                                                    style="
                                                                        background-color: #0f1175;
                                                                    "
                                                                >
                                                                    <label
                                                                        style="
                                                                            color: white;
                                                                        "
                                                                        >Sub
                                                                        Status :
                                                                        {{
                                                                            itemdetail.sub_status_name
                                                                        }}</label
                                                                    >
                                                                </v-chip>
                                                                <v-chip
                                                                    small
                                                                    style="
                                                                        background-color: #135c39;
                                                                    "
                                                                    class="mb-2 mr-2 lighten-1"
                                                                    v-if="
                                                                        itemdetail.project_name ==
                                                                            'CDAX' ||
                                                                            itemdetail.project_name ==
                                                                                'S-Print'
                                                                    "
                                                                >
                                                                    <v-avatar
                                                                        left
                                                                    >
                                                                        <v-icon
                                                                            small
                                                                            color="white"
                                                                            >mdi-car-brake-retarder</v-icon
                                                                        > </v-avatar
                                                                    ><label
                                                                        style="
                                                                            color: white;
                                                                        "
                                                                        >Cdax :
                                                                        {{
                                                                            itemdetail.status_name
                                                                        }}</label
                                                                    >
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>

                                                        <v-row>
                                                            <v-col
                                                                cols="12"
                                                                lg="12"
                                                            >
                                                                <v-row
                                                                    style="
                                                                        margin-top: -12px;
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >Case
                                                                                Title
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    itemdetail.case_title
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >Project/TeamName
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    itemdetail.project_name
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    itemdetail.team_name
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>

                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >CustomerName
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    customer_name
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >CustomerTel
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    itemdetail.customer_tel
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >Email(Cdax)
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    itemdetail.customer_email
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="12"
                                                                    >
                                                                        <label
                                                                            style="
                                                                                font-size: 14px;
                                                                                color: black;
                                                                            "
                                                                        >
                                                                            <b
                                                                                >Email(CE)
                                                                                :</b
                                                                            >&nbsp;&nbsp;<label
                                                                                style="
                                                                                    font-size: 14px;
                                                                                "
                                                                                >{{
                                                                                    itemdetail.email_in_cso
                                                                                }}</label
                                                                            >
                                                                        </label>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                    >
                                                        <v-row>
                                                            <span
                                                                class="font-weight-bold subtitle-1"
                                                                style="
                                                                    color: black;
                                                                "
                                                                >ติดต่อลูกค้าได้หรือไม่</span
                                                            >
                                                        </v-row>
                                                        <v-row>
                                                            <v-radio-group
                                                                v-model="
                                                                    selectcustomer
                                                                "
                                                                @change="
                                                                    selectcus(
                                                                        datadetail.length,
                                                                        selectcustomer
                                                                    )
                                                                "
                                                                :rules="
                                                                    CustomerR
                                                                "
                                                                required
                                                            >
                                                                <v-radio
                                                                    color="green"
                                                                    label="ได้"
                                                                    value="Y"
                                                                ></v-radio>
                                                                <v-radio
                                                                    color="red"
                                                                    label="ไม่ได้"
                                                                    value="N"
                                                                ></v-radio>
                                                                <v-radio
                                                                    color="orange"
                                                                    label="ยังไม่ได้ติดต่อกับลูกค้า"
                                                                    value="R"
                                                                ></v-radio>
                                                                <v-radio
                                                                    color="#555555"
                                                                    label="ลูกค้าไม่สะดวกคุย"
                                                                    value="N/A"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col
                                                                style="
                                                                    margin-left: -10px;
                                                                "
                                                            >
                                                                <v-textarea
                                                                    v-if="
                                                                        selectcustomer !=
                                                                            '' &&
                                                                            selectcustomer !=
                                                                                'N' &&
                                                                            selectcustomer !=
                                                                                'R' &&
                                                                            selectcustomer !=
                                                                                'N/A'
                                                                    "
                                                                    :rules="
                                                                        RemarkR
                                                                    "
                                                                    required
                                                                    v-model="
                                                                        remarkcustomerarray[
                                                                            i
                                                                        ]
                                                                    "
                                                                    label="Remark"
                                                                    auto-grow
                                                                    outlined
                                                                    rows="1"
                                                                    row-height="15"
                                                                ></v-textarea>
                                                                <v-textarea
                                                                    v-if="
                                                                        selectcustomer !=
                                                                            '' &&
                                                                            selectcustomer !=
                                                                                'Y' &&
                                                                            selectcustomer !=
                                                                                'R' &&
                                                                            selectcustomer !=
                                                                                'N' &&
                                                                            selectcustomer !=
                                                                                'N/A'
                                                                    "
                                                                    :rules="
                                                                        RemarkR
                                                                    "
                                                                    required
                                                                    v-model="
                                                                        remarkcustomer
                                                                    "
                                                                    label="Remark"
                                                                    auto-grow
                                                                    outlined
                                                                    rows="1"
                                                                    row-height="15"
                                                                ></v-textarea>

                                                                <v-autocomplete
                                                                    v-if="
                                                                        selectcustomer ==
                                                                            'R'
                                                                    "
                                                                    v-model="
                                                                        remarkcustomer
                                                                    "
                                                                    :items="
                                                                        messagecomment
                                                                    "
                                                                    label="Comment"
                                                                    :rules="[
                                                                        requiredcomment,
                                                                    ]"
                                                                    required
                                                                    small-chips
                                                                    outlined
                                                                    clearable
                                                                    multiple
                                                                    style="
                                                                        color: yellow;
                                                                    "
                                                                    color="blue-grey lighten-2"
                                                                >
                                                                    <template
                                                                        v-slot:selection="{
                                                                            item,
                                                                            select,
                                                                            selected,
                                                                        }"
                                                                    >
                                                                        <v-chip
                                                                            :input-value="
                                                                                selected
                                                                            "
                                                                            close
                                                                            small
                                                                            @click="
                                                                                select
                                                                            "
                                                                            @click:close="
                                                                                removecomment(
                                                                                    item,
                                                                                    i
                                                                                )
                                                                            "
                                                                        >
                                                                            <strong
                                                                                >{{
                                                                                    item
                                                                                }}</strong
                                                                            >
                                                                        </v-chip>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <!-- <v-btn
                                v-if="
                                  (selectcustomer != '' &&
                                    selectcustomer != 'Y' &&
                                    selectcustomer != 'R' ) ||
                                    (selectcustomer != '' &&
                                      selectcustomer != 'Y' &&
                                      selectcustomer != 'R' &&
                                      adminstatus == 'Programmer')
                                "
                                @click="
                                  skip == 'Y'
                                    ? ((skip = ''), (remarkcustomer = ''))
                                    : ((skip = 'Y'),
                                      (remarkcustomer =
                                        'โทรไม่ติดเกิน 3 ครั้ง'))
                                "
                                :style="
                                  skip == 'Y'
                                    ? 'background: red; background: -webkit-linear-gradient(red, yellow); background: -o-linear-gradient(red, yellow); background: -moz-linear-gradient(red, yellow); background: linear-gradient(red, yellow);color:white'
                                    : ''
                                "
                                >>> Skip</v-btn
                              > -->
                                                        </v-row>
                                                        <v-row>
                                                            <v-col
                                                                style="
                                                                    margin-left: -10px;
                                                                "
                                                            >
                                                                <div
                                                                    v-if="
                                                                        selectcustomer !=
                                                                            'N' &&
                                                                            selectcustomer !=
                                                                                'R' &&
                                                                            selectcustomer !=
                                                                                'N/A' &&
                                                                            selectproblem[
                                                                                i
                                                                            ] !=
                                                                                'T'
                                                                    "
                                                                >
                                                                    <span
                                                                        class="font-weight-bold subtitle-1"
                                                                        style="
                                                                            color: black;
                                                                        "
                                                                        >ลูกค้าพอใจกับการบริการครั้งนี้หรือไม่
                                                                    </span>

                                                                    <br />
                                                                    <v-btn
                                                                        class="ma-2"
                                                                        text
                                                                        style="
                                                                            border: 2px
                                                                                solid
                                                                                black;
                                                                        "
                                                                        icon
                                                                        :rules="
                                                                            IconR
                                                                        "
                                                                        required
                                                                        @click="
                                                                            selected(
                                                                                '1',
                                                                                i
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            class="display-1"
                                                                            :color="
                                                                                colorselect[
                                                                                    i
                                                                                ] ==
                                                                                '1'
                                                                                    ? 'red'
                                                                                    : ''
                                                                            "
                                                                            >mdi-emoticon-sad</v-icon
                                                                        >
                                                                    </v-btn>

                                                                    <v-btn
                                                                        class="ma-2"
                                                                        style="
                                                                            border: 2px
                                                                                solid
                                                                                black;
                                                                        "
                                                                        text
                                                                        icon
                                                                        :rules="
                                                                            IconR
                                                                        "
                                                                        required
                                                                        @click="
                                                                            selected(
                                                                                '2',
                                                                                i
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            class="display-1"
                                                                            :color="
                                                                                colorselect[
                                                                                    i
                                                                                ] ==
                                                                                '2'
                                                                                    ? 'amber darken-2'
                                                                                    : ''
                                                                            "
                                                                            >mdi-emoticon-neutral</v-icon
                                                                        >
                                                                    </v-btn>
                                                                    <v-btn
                                                                        class="ma-2"
                                                                        style="
                                                                            border: 2px
                                                                                solid
                                                                                black;
                                                                        "
                                                                        text
                                                                        icon
                                                                        :rules="
                                                                            IconR
                                                                        "
                                                                        required
                                                                        @click="
                                                                            selected(
                                                                                '3',
                                                                                i
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            class="display-1"
                                                                            :color="
                                                                                colorselect[
                                                                                    i
                                                                                ] ==
                                                                                '3'
                                                                                    ? 'green'
                                                                                    : ''
                                                                            "
                                                                            >mdi-emoticon-excited</v-icon
                                                                        >
                                                                    </v-btn>

                                                                    <!-- <v-combobox
                                v-if="selecticon == '1'"
                                v-model="hpc_level_reason"
                                :items="items1"
                                chips
                                clearable
                                label="เหตุผล"
                                :rules="[required]"
                                required
                                multiple
                                solo
                              >
                                <template
                                  v-slot:selection="{
                                    item,
                                    select,
                                    selected,
                                  }"
                                >
                                  <v-chip
                                    :input-value="selected"
                                    close
                                    small
                                    @click="select"
                                    @click:close="remove(item)"
                                  >
                                    <strong>{{ item }}</strong>
                                  </v-chip>
                                </template>
                              </v-combobox> -->
                                                                    <v-autocomplete
                                                                        v-if="
                                                                            colorselect[
                                                                                i
                                                                            ] ==
                                                                                '1'
                                                                        "
                                                                        v-model="
                                                                            hpc_level_reason[
                                                                                i
                                                                            ]
                                                                        "
                                                                        :items="
                                                                            items1
                                                                        "
                                                                        label="เหตุผล"
                                                                        :rules="[
                                                                            required,
                                                                        ]"
                                                                        required
                                                                        small-chips
                                                                        outlined
                                                                        clearable
                                                                        multiple
                                                                        style="
                                                                            color: yellow;
                                                                        "
                                                                        color="blue-grey lighten-2"
                                                                    >
                                                                        <template
                                                                            v-slot:selection="{
                                                                                item,
                                                                                select,
                                                                                selected,
                                                                            }"
                                                                        >
                                                                            <v-chip
                                                                                :input-value="
                                                                                    selected
                                                                                "
                                                                                close
                                                                                small
                                                                                @click="
                                                                                    select
                                                                                "
                                                                                @click:close="
                                                                                    remove(
                                                                                        item,
                                                                                        i
                                                                                    )
                                                                                "
                                                                            >
                                                                                <strong
                                                                                    >{{
                                                                                        item
                                                                                    }}</strong
                                                                                >
                                                                            </v-chip>
                                                                        </template>
                                                                        <!-- <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No results matching "<strong>{{ search }}</strong
                              >". Press <kbd>enter</kbd> to create a new one
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template> -->
                                                                    </v-autocomplete>
                                                                    <v-autocomplete
                                                                        v-if="
                                                                            colorselect[
                                                                                i
                                                                            ] ==
                                                                                '2'
                                                                        "
                                                                        v-model="
                                                                            hpc_level_reason[
                                                                                i
                                                                            ]
                                                                        "
                                                                        :items="
                                                                            items2
                                                                        "
                                                                        label="เหตุผล"
                                                                        :rules="[
                                                                            required,
                                                                        ]"
                                                                        required
                                                                        small-chips
                                                                        outlined
                                                                        clearable
                                                                        multiple
                                                                        style="
                                                                            color: yellow;
                                                                        "
                                                                        color="blue-grey lighten-2"
                                                                    >
                                                                        <template
                                                                            v-slot:selection="{
                                                                                item,
                                                                                select,
                                                                                selected,
                                                                            }"
                                                                        >
                                                                            <v-chip
                                                                                :input-value="
                                                                                    selected
                                                                                "
                                                                                close
                                                                                small
                                                                                @click="
                                                                                    select
                                                                                "
                                                                                @click:close="
                                                                                    remove(
                                                                                        item,
                                                                                        i
                                                                                    )
                                                                                "
                                                                            >
                                                                                <strong
                                                                                    >{{
                                                                                        item
                                                                                    }}</strong
                                                                                >
                                                                            </v-chip>
                                                                        </template>
                                                                        <!-- <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No results matching "<strong>{{ search }}</strong
                              >". Press <kbd>enter</kbd> to create a new one
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template> -->
                                                                    </v-autocomplete>

                                                                    <v-autocomplete
                                                                        v-if="
                                                                            colorselect[
                                                                                i
                                                                            ] ==
                                                                                '3'
                                                                        "
                                                                        v-model="
                                                                            hpc_level_reason[
                                                                                i
                                                                            ]
                                                                        "
                                                                        :items="
                                                                            items3
                                                                        "
                                                                        label="เหตุผล"
                                                                        :rules="[
                                                                            required,
                                                                        ]"
                                                                        required
                                                                        small-chips
                                                                        outlined
                                                                        clearable
                                                                        multiple
                                                                        style="
                                                                            color: yellow;
                                                                        "
                                                                        color="blue-grey lighten-2"
                                                                    >
                                                                        <template
                                                                            v-slot:selection="{
                                                                                item,
                                                                                select,
                                                                                selected,
                                                                            }"
                                                                        >
                                                                            <v-chip
                                                                                :input-value="
                                                                                    selected
                                                                                "
                                                                                close
                                                                                small
                                                                                @click="
                                                                                    select
                                                                                "
                                                                                @click:close="
                                                                                    remove(
                                                                                        item,
                                                                                        i
                                                                                    )
                                                                                "
                                                                            >
                                                                                <strong
                                                                                    >{{
                                                                                        item
                                                                                    }}</strong
                                                                                >
                                                                            </v-chip>
                                                                        </template>
                                                                        <!-- <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              No results matching "<strong>{{ search }}</strong
                              >". Press <kbd>enter</kbd> to create a new one
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template> -->
                                                                    </v-autocomplete>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="4"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R'
                                                        "
                                                    >
                                                        <v-row
                                                            style="
                                                                margin-left: -20px;
                                                            "
                                                        >
                                                            <v-col>
                                                                <span
                                                                    class="font-weight-bold subtitle-1"
                                                                    style="
                                                                        color: black;
                                                                    "
                                                                    >ปัญหายังไม่ได้รับการแก้ไข
                                                                    หรือ
                                                                    มีอาการเสียอย่างอื่นเพิ่มเติม</span
                                                                >
                                                                <v-radio-group
                                                                    v-model="
                                                                        selectproblem[
                                                                            i
                                                                        ]
                                                                    "
                                                                    :rules="
                                                                        ProblemR
                                                                    "
                                                                    @change="
                                                                        problem(
                                                                            i
                                                                        )
                                                                    "
                                                                    required
                                                                >
                                                                    <v-radio
                                                                        color="green"
                                                                        label="ได้รับการแก้ไข"
                                                                        value="Y"
                                                                    ></v-radio>
                                                                    <v-radio
                                                                        color="red"
                                                                        label="ไม่ได้รับการแก้ไข"
                                                                        value="N"
                                                                    ></v-radio>
                                                                    <v-radio
                                                                        color="blue"
                                                                        label="ลูกค้าขอเทสเครื่อง"
                                                                        value="T"
                                                                    ></v-radio>
                                                                </v-radio-group>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row
                                                            style="
                                                                margin-left: -20px;
                                                            "
                                                        >
                                                            <v-col>
                                                                <div
                                                                    :style="
                                                                        selecticon ==
                                                                        ''
                                                                            ? 'margin-top:0px'
                                                                            : 'margin-top:0px'
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            selectcustomer !=
                                                                                'N' &&
                                                                                selectproblem[
                                                                                    i
                                                                                ] !=
                                                                                    'N'
                                                                        "
                                                                        class="font-weight-bold subtitle-1"
                                                                        style="
                                                                            color: black;
                                                                        "
                                                                        >ติดต่อลูกค้าอีกครั้ง?
                                                                    </span>
                                                                    <v-radio-group
                                                                        v-if="
                                                                            selectcustomer !=
                                                                                'N' &&
                                                                                selectproblem[
                                                                                    i
                                                                                ] !=
                                                                                    'N'
                                                                        "
                                                                        v-model="
                                                                            selectcustomeragain[
                                                                                i
                                                                            ]
                                                                        "
                                                                        :rules="
                                                                            CustomerR
                                                                        "
                                                                        required
                                                                    >
                                                                        <v-radio
                                                                            color="green"
                                                                            label="ติดต่อใหม่"
                                                                            value="Y"
                                                                        ></v-radio>
                                                                        <v-radio
                                                                            color="red"
                                                                            label="ไม่ติดต่อใหม่"
                                                                            value="N"
                                                                        ></v-radio>
                                                                    </v-radio-group>

                                                                    <v-textarea
                                                                        style="
                                                                            margin-top: 10px;
                                                                        "
                                                                        v-if="
                                                                            selectproblem[
                                                                                i
                                                                            ] ==
                                                                                'N' ||
                                                                                selectcustomeragain[
                                                                                    i
                                                                                ] ==
                                                                                    'Y'
                                                                        "
                                                                        label="Reason"
                                                                        v-model="
                                                                            remarkproblem[
                                                                                i
                                                                            ]
                                                                        "
                                                                        auto-grow
                                                                        outlined
                                                                        rows="1"
                                                                        row-height="15"
                                                                        :rules="
                                                                            ReasonR
                                                                        "
                                                                        required
                                                                    ></v-textarea>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row
                                                            style="
                                                                margin-left: -20px;
                                                                margin-top: -20px;
                                                            "
                                                        >
                                                            <v-col>
                                                                <div
                                                                    style=""
                                                                    v-if="
                                                                        selectcustomer !=
                                                                            'N' &&
                                                                            selectproject !=
                                                                                'BENCH' &&
                                                                            selectproblem[
                                                                                i
                                                                            ] !=
                                                                                'T'
                                                                    "
                                                                >
                                                                    <span
                                                                        class="font-weight-bold subtitle-1"
                                                                        style="
                                                                            color: black;
                                                                        "
                                                                        v-if="
                                                                            selectcustomer !=
                                                                                'N'
                                                                        "
                                                                        >ช่างกรอก
                                                                        email
                                                                        ในใบงานมาหรือไม่
                                                                    </span>
                                                                    <v-radio-group
                                                                        v-if="
                                                                            selectcustomer !=
                                                                                'N' &&
                                                                                selectproject !=
                                                                                    'BENCH'
                                                                        "
                                                                        v-model="
                                                                            selectcso[
                                                                                i
                                                                            ]
                                                                        "
                                                                        :rules="
                                                                            CsoEmailR
                                                                        "
                                                                        required
                                                                    >
                                                                        <v-radio
                                                                            style="
                                                                                color: black;
                                                                            "
                                                                            color="green"
                                                                            label="กรอก"
                                                                            value="Y"
                                                                        ></v-radio>
                                                                        <v-radio
                                                                            color="red"
                                                                            label="ไม่กรอก"
                                                                            value="N"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <!-- <v-row style="margin-left:-20px;">
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A' &&
                                selectproblem[i] != 'T'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >{{
                                selectproject == "ONSITE"
                                  ? "ช่างใส่แมสค์ตลอดเวลาที่ปฏิบัติหน้าที่หรือไม่"
                                  : "พนักงานที่ศูนย์บริการใส่แมสค์ตลอดเวลาที่ปฏิบัติหน้าที่หรือไม่"
                              }}</span
                            >
                            <v-radio-group
                              v-model="hpc_covid_1"
                              :rules="hpc_covid_1R"
                              required
                            >
                              <v-radio
                                color="green"
                                label="ใช่"
                                value="Y"
                              ></v-radio>
                              <v-radio
                                color="red"
                                label="ไม่ใช่"
                                value="N"
                              ></v-radio>
                              <v-radio
                                color="orange"
                                label="ไม่แน่ใจ"
                                value="N/A"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A' &&
                                selectproblem[i] != 'T'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >{{
                                selectproject == "ONSITE"
                                  ? "ช่างใช้แอลกอฮอล์ล้างมือก่อนและหลังปฎิบัติหน้าที่หรือไม่"
                                  : "พนักงานที่ศูนย์บริการใช้แอลกอฮอล์ล้างมือก่อนและหลังปฎิบัติหน้าที่หรือไม่"
                              }}</span
                            >
                            <v-radio-group
                              v-model="hpc_covid_2"
                              :rules="hpc_covid_2R"
                              required
                            >
                              <v-radio
                                color="green"
                                label="ใช่"
                                value="Y"
                              ></v-radio>
                              <v-radio
                                color="red"
                                label="ไม่ใช่"
                                value="N"
                              ></v-radio>
                              <v-radio
                                color="orange"
                                label="ไม่แน่ใจ"
                                value=" N/A"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A' &&
                                selectproblem[i] != 'T'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >{{
                                selectproject == "ONSITE"
                                  ? "ช่างทำความสะอาดเครื่องหลังปฏิบัติหน้าที่หรือไม่"
                                  : "พนักงานที่ศูนย์บริการทำความสะอาดพื้นที่หลังปฏิบัติหน้าที่หรือไม่"
                              }}</span
                            >
                            <v-radio-group
                              v-model="hpc_covid_3"
                              :rules="hpc_covid_3R"
                              required
                            >
                              <v-radio
                                color="green"
                                label="ใช่"
                                value="Y"
                              ></v-radio>
                              <v-radio
                                color="red"
                                label="ไม่ใช่"
                                value="N"
                              ></v-radio>
                              <v-radio
                                color="orange"
                                label="ไม่แน่ใจ"
                                value="N/A"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row> -->
                                                <!-- เฉพาะงาน Onsite -->
                                                <v-row
                                                    style="margin-left: -20px"
                                                >
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE'
                                                        "
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ถามคำถามประเมินช่างกับลูกค้าหรือไม่
                                                            ?
                                                        </span>
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_4
                                                            "
                                                            :rules="
                                                                hpc_covid_4R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="ถาม"
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่ถาม"
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE' &&
                                                                hpc_covid_4 ==
                                                                    'Y'
                                                        "
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ช่างโทรนัดหมายก่อนเข้าซ่อมหรือไม่</span
                                                        >
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_5
                                                            "
                                                            :rules="
                                                                hpc_covid_5R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="โทร"
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่โทร"
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE' &&
                                                                hpc_covid_4 ==
                                                                    'Y'
                                                        "
                                                    >
                                                        <!-- <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ลูกค้าให้คะแนนกี่คะแนน
                                                            ด้านการบริการของช่างโดยภาพรวม</span
                                                        >
                                                        <div
                                                            style="
                                                                margin-top: 40px;
                                                            "
                                                        >
                                                            <v-slider
                                                                v-model="
                                                                    hpc_covid_9
                                                                "
                                                                :rules="
                                                                    hpc_covid_9R
                                                                "
                                                                label="เกณฑ์ให้คะแนน 1-10"
                                                                min="1"
                                                                max="10"
                                                                step="1"
                                                                thumb-label
                                                            ></v-slider> -->
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ช่างเข้าตรงเวลาตามที่นัดหมายหรือไม่</span
                                                        >
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_10
                                                            "
                                                            :rules="
                                                                hpc_covid_10R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="ตรง"
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่ตรง"
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>
                                                <v-row
                                                    style="margin-left: -20px"
                                                >
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE' &&
                                                                hpc_covid_4 ==
                                                                    'Y'
                                                        "
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ช่างดูมีความเป็นมืออาชีพ
                                                            โดยสวมเสื้อของบริษัท
                                                            HP
                                                            ขณะเข้ามาให้บริการหรือไม่
                                                            ?</span
                                                        >
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_6
                                                            "
                                                            :rules="
                                                                hpc_covid_6R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="ดูมีความเป็นมืออาชีพ / สวมใส่เสื้อ HP "
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่มีความเป็นมืออาชีพ / ไม่สวมใส่เสื้อ HP "
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE' &&
                                                                hpc_covid_4 ==
                                                                    'Y'
                                                        "
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ช่างได้อธิบายถึงปัญหาที่เกิดขึ้น
                                                            และวิธีในการแก้ไขหรือไม่
                                                            ?</span
                                                        >
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_7
                                                            "
                                                            :rules="
                                                                hpc_covid_7R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="อธิบาย"
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่ได้อธิบาย"
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        v-if="
                                                            selectcustomer !=
                                                                'N' &&
                                                                selectcustomer !=
                                                                    'R' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'N' &&
                                                                selectcustomer !=
                                                                    'N/A' &&
                                                                selectproblem[
                                                                    i
                                                                ] != 'T' &&
                                                                selectproject ==
                                                                    'ONSITE' &&
                                                                hpc_covid_4 ==
                                                                    'Y'
                                                        "
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >#
                                                            ช่างได้แจ้งให้ลูกค้าทราบ
                                                            เพื่อยืนยันว่าปัญหาได้รับการแก้ไขเรียบร้อยแล้วหรือไม่
                                                            ?</span
                                                        >
                                                        <v-radio-group
                                                            v-model="
                                                                hpc_covid_8
                                                            "
                                                            :rules="
                                                                hpc_covid_8R
                                                            "
                                                            required
                                                        >
                                                            <v-radio
                                                                color="green"
                                                                label="แจ้ง"
                                                                value="Y"
                                                            ></v-radio>
                                                            <v-radio
                                                                color="red"
                                                                label="ไม่ได้แจ้ง"
                                                                value="N"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>

                                                <!-- PREMIUM / STUDENT -->
                                                <v-row
                                                    style="margin-left: -20px"
                                                    v-if="
                                                        selectcustomer != 'N' &&
                                                            selectcustomer !=
                                                                'R' &&
                                                            selectproblem[i] !=
                                                                'N' &&
                                                            selectcustomer !=
                                                                'N/A' &&
                                                            selectproblem[i] !=
                                                                'T' &&
                                                            chkPremium(
                                                                itemdetail.case_title
                                                            ) == true
                                                    "
                                                >
                                                    <v-col
                                                        cols="12"
                                                        sm="3"
                                                        md="2"
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                        >
                                                            เกณฑ์การให้คะแนน </span
                                                        ><br />
                                                        5 : พอใจ<br />
                                                        4 : พอใจบ้าง <br />
                                                        3 : เป็นกลาง<br />
                                                        2 : ไม่พอใจบ้าง <br />
                                                        1 : ไม่พอใจ
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="9"
                                                        md="6"
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                        >
                                                            คุณพอใจกับความเร็วของการบริการเพื่อแก้ไขปัญหาของคุณหรือไม่
                                                        </span>
                                                        <v-rating
                                                            v-model="
                                                                hpc_premium_1
                                                            "
                                                            background-color="green lighten-3"
                                                            color="green"
                                                            large
                                                        ></v-rating>
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >คุณพอใจเพียงใดที่คุณได้รับการแจ้งอัพเดทสถานะงานตลอดตั้งแต่เปิดงาน</span
                                                        >

                                                        <v-rating
                                                            v-model="
                                                                hpc_premium_2
                                                            "
                                                            background-color="green lighten-3"
                                                            color="green"
                                                            large
                                                        ></v-rating>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                    >
                                                        <span
                                                            class="font-weight-bold subtitle-1"
                                                            style="color: black"
                                                            >ขอคำแนะนำว่าเราจะพัฒนาตรงนี้ให้ดียิ่งขึ้นไปสำหรับคุณลูกค้าได้อย่างไร</span
                                                        >
                                                        <v-textarea
                                                            rows="3"
                                                            v-model="
                                                                hpc_premium_3
                                                            "
                                                            required
                                                        >
                                                        </v-textarea>
                                                    </v-col>
                                                </v-row>

                                                <!-- <v-row style="margin-left:-20px;">
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >จากการที่ HP เช้าให้การบริการในครั้งล่าสุด
                              ลูกค้ามีความเห็นหรือคำแนะนำใดๆที่จะช่วยให้ทาง HP
                              พัฒนาการบริการให้ดียิ่งขึ้นหรือไม่ ?</span
                            >
                            <v-textarea
                              :rules="cust_suggestR"
                              v-model="cust_suggest"
                              required
                              auto-grow
                              outlined
                              rows="1"
                              row-height="200"
                            ></v-textarea>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >จากประสบการ์ณของลูกค้า
                              ลูกค้าคิดว่าผู้ให้บริการของ คอมพิวเตอร์/ปรินเตอร์
                              แบรนด์ไหน ที่มีการบริการที่ดีที่สุด</span
                            >
                            <v-textarea
                              :rules="cust_recommendR"
                              v-model="cust_recommend"
                              required
                              auto-grow
                              outlined
                              rows="1"
                              row-height="200"
                            ></v-textarea>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="
                              selectcustomer != 'N' &&
                                selectcustomer != 'R' &&
                                selectproblem[i] != 'N' &&
                                selectcustomer != 'N/A'
                            "
                          >
                            <span
                              class="font-weight-bold subtitle-1"
                              style="color:black;"
                              >เพราะอะไรถึงให้ (แบรนด์ในคำตอบข้อ 2)
                              เป็นผู้ให้บริการที่ดีที่สุด</span
                            >
                            <v-textarea
                              style="margin-top:25px;"
                              :rules="cust_recommend_reasonR"
                              v-model="cust_recommend_reason"
                              required
                              auto-grow
                              outlined
                              rows="1"
                              row-height="200"
                            ></v-textarea>
                          </v-col>
                        </v-row> -->
                                                <v-row>
                                                    <v-col
                                                        cols="6"
                                                        md="4"
                                                    ></v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-btn
                                                            v-if="
                                                                colorselect[
                                                                    i
                                                                ] != '' ||
                                                                    selectcustomer ==
                                                                        'N' ||
                                                                    selectcustomer ==
                                                                        'R' ||
                                                                    (selectcustomer ==
                                                                        'N/A' &&
                                                                        datacase.hpc_status ==
                                                                            'ok') ||
                                                                    (selectproblem[
                                                                        i
                                                                    ] == 'T' &&
                                                                        datacase.hpc_status ==
                                                                            'ok')
                                                            "
                                                            @click="
                                                                save(
                                                                    datadetail.length
                                                                )
                                                            "
                                                            style="
                                                                text-align: center;
                                                            "
                                                            color="primary"
                                                            :disabled="!valid"
                                                        >
                                                            <v-icon left
                                                                >mdi-content-save</v-icon
                                                            >Save
                                                        </v-btn>
                                                        <v-btn
                                                            @click="
                                                                closedialog()
                                                            "
                                                            style="
                                                                margin-left: 10px;
                                                                text-align: center;
                                                            "
                                                            color="red"
                                                        >
                                                            <v-icon
                                                                left
                                                                color="white"
                                                                >mdi-close</v-icon
                                                            ><label
                                                                style="
                                                                    color: white;
                                                                    font-size: 14px;
                                                                "
                                                                >Close</label
                                                            >
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="4"></v-col>
                                                </v-row>
                                                <template>
                                                    <div id="lognote">
                                                        <v-alert
                                                            dense
                                                            border="bottom"
                                                            type="primary"
                                                            icon="mdi-information"
                                                            >LOG NOTE</v-alert
                                                        >
                                                        <v-card-text>
                                                            <v-container>
                                                                <v-row>
                                                                    <v-col
                                                                        cols="12"
                                                                        sm="6"
                                                                        md="4"
                                                                    >
                                                                        <v-textarea
                                                                            v-model="
                                                                                computedGenLog
                                                                            "
                                                                            label="Noted"
                                                                        ></v-textarea>
                                                                        <v-btn
                                                                            @click="
                                                                                saveLog()
                                                                            "
                                                                            tile
                                                                            color="success"
                                                                        >
                                                                            <v-icon
                                                                                left
                                                                                >mdi-content-save</v-icon
                                                                            >Save
                                                                            Log </v-btn
                                                                        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                        <v-btn
                                                                            v-if="
                                                                                status ==
                                                                                    'CloseCase'
                                                                            "
                                                                            @click="
                                                                                doCopy()
                                                                            "
                                                                            tile
                                                                            color="primary"
                                                                        >
                                                                            <v-icon
                                                                                left
                                                                                >mdi-content-copy</v-icon
                                                                            >Copy
                                                                            Log
                                                                        </v-btn>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        sm="6"
                                                                        md="4"
                                                                    >
                                                                        <v-card
                                                                            class="mx-auto"
                                                                            elevation="0"
                                                                        >
                                                                            <v-textarea
                                                                                v-model="
                                                                                    detailcase.lognote
                                                                                "
                                                                                label="LOG HYBRID"
                                                                                solo
                                                                                flat
                                                                                readonly
                                                                                outlined
                                                                                height="235"
                                                                                persistent-hint
                                                                                hint="HYBRID LOGNOTE"
                                                                            ></v-textarea>
                                                                        </v-card>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        sm="6"
                                                                        md="4"
                                                                    >
                                                                        <v-card
                                                                            class="mx-auto"
                                                                            elevation="0"
                                                                        >
                                                                            <v-textarea
                                                                                v-if="
                                                                                    detailcase.cdax_log !==
                                                                                        null
                                                                                "
                                                                                v-model="
                                                                                    detailcase
                                                                                        .cdax_log
                                                                                        .log
                                                                                "
                                                                                label="LOG HP"
                                                                                solo
                                                                                flat
                                                                                readonly
                                                                                outlined
                                                                                height="235"
                                                                                persistent-hint
                                                                                hint="HP LOGNOTE"
                                                                            ></v-textarea>
                                                                        </v-card>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card-text>
                                                    </div>
                                                </template>
                                                <view-engineerformation
                                                    :detailcase="detailcase"
                                                    :active_tab="active_tab"
                                                />
                                                <view-productinformation
                                                    :detailcase="detailcase"
                                                />

                                                <view-partformation
                                                    :detailcase="detailcase"
                                                />
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import Sumcard from "../../../components/Sumcard"
import Image from "../../../components/ViewImage"
import ViewEngineerInformation from "../components/ViewEngineerInformation"
import ViewProductInformation from "../components/ViewProductInformation"
import ViewCustomerInformation from "../components/ViewCustomerInformation"
import ViewHpiPartInformation from "../components/ViewHpiPartInformation"
import ViewLogInformation from "../components/ViewLogInformation"
import viewcdax from "../../../components/ViewCdax"
export default {
    components: {
        "sum-card": Sumcard,
        "view-customerinformation": ViewCustomerInformation,
        "view-partformation": ViewHpiPartInformation,
        "view-loginformation": ViewLogInformation,
        "view-engineerformation": ViewEngineerInformation,
        "view-productinformation": ViewProductInformation,
        "view-image": Image,
        "view-cdax": viewcdax,
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),

        computedGenLog: {
            get() {
                this.text_closecase =
                    this.status == "CloseCase"
                        ? this.detailcase.text_closecase +
                          "/" +
                          localStorage.fullname
                        : ""
                return this.text_closecase
            },
            set(val) {
                this.log.log_note = val
            },
        },
        ...mapState(["isLoading"]),
        inited(viewer) {
            this.view.push(viewer)
        },
        showImage(id) {
            this.view.map((each) => {
                if (each.element.id == "viewer" + id) {
                    this.$viewer = each
                    this.$viewer.show()
                }
            })
        },
        computedDateFormatted1() {
            this.editItem.expireddate = this.formatDate(this.date1)
            return this.editItem.expireddate
        },
    },
    mounted() {
        this.getAjax("1")
    },
    data() {
        return {
            hpc_covid_1: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_2: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_3: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_4: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_5: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_6: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_7: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_8: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_9: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_covid_10: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            hpc_premium_1: "",
            hpc_premium_2: "",
            hpc_premium_3: "",
            cust_suggest: "",
            cust_recommend: "",
            cust_recommend_reason: "",
            messagecomment: [
                "ขาด เขียนใบงานให้ตรงกับ, บริษัทแจ้งซ่อม , Project",
                "ขาด วัน/เดือน/ปี_เวลา เเจ้งงาน",
                "ขาด วัน/เดือน/ปี_เวลา เข้าดำเนินการ",
                "ขาด S/N ที่เเจ้งซ่อม",
                "ขาด เลขงานที่แจ้ง",
                "ขาด ชื่อ-เบอร์โทร และที่อยู่ ลายเซ็นต์ตัวบรรจงของลูกค้า",
            ],
            viewpendingtab: false,
            statustab: false,
            casetab: false,
            colorselect: [],
            skip: "",
            sortname: "",
            sortcondition: "",
            sorttatcondition: "",
            sortadmincondition: "",
            projectidstatus: "",
            searchtext: "",
            selectalltoday: false,
            selectallbooking: false,
            logtype: ["Log", "Follow Up"],
            log: {
                log_note: "",
            },
            text: "Success, Log has been saved",
            text_closecase: "",
            sumtitlebooking: "",
            search: "",
            headerz: [
                {
                    text: "#",
                    value: "checkbox",
                    class: "text-uppercase pink darken-4 white--text",
                    sortable: false,
                },
                {
                    text: "CaseID/Title",
                    value: "sumtitlebooking",
                    class: "text-uppercase pink darken-4 white--text",
                    sortable: false,
                },
            ],
            headers: [
                {
                    text: "#",
                    value: "checkbox",
                    class: "text-uppercase red darken-4 white--text",
                    sortable: false,
                },
                {
                    text: "CaseID/Title",
                    value: "sumtitlebooking",
                    class: "text-uppercase red darken-4 white--text",
                    sortable: false,
                },
            ],
            adminstatus: localStorage.role_name,

            databooking: [],
            status: "",
            datahpctoday: [],
            dialogbooking: false,
            checkedbooking: [],
            showpic1: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            view: [],
            cso: {
                csoimage: {
                    images: [],
                },
            },
            uefi: {
                uefiimage: {
                    images: [],
                },
            },
            datapending: [],
            checked: [],
            caseid: "",
            buttonbad: false,
            buttonnormal: false,
            buttongood: false,
            buttonphone: false,
            selecthappycallteam: "",
            valid: false,
            datapage: [],
            datacase: {
                hpc_by: "",
                hpc_status: "",
            },
            IconR: [(v) => !!v || "Icon is required"],
            ReasonR: [(v) => !!v || "Reason is required"],
            CustomerR: [(v) => !!v || "Customer is required"],
            hpc_covid_1R: [(v) => !!v || "Covid #1 is required"],
            hpc_covid_2R: [(v) => !!v || "Covid #2 is required"],
            hpc_covid_3R: [(v) => !!v || "Covid #3 is required"],
            hpc_covid_4R: [(v) => !!v || "ce  is required"],
            hpc_covid_5R: [(v) => !!v || "ce_greeting  is required"],
            hpc_covid_6R: [(v) => !!v || "ce_personality is required"],
            hpc_covid_7R: [(v) => !!v || "ce_resolve  is required"],
            hpc_covid_8R: [(v) => !!v || "ce_advice  is required"],
            hpc_covid_9R: [(v) => !!v || "ce_quality is required"],
            hpc_covid_10: [(v) => !!v || "appointment_time is required"],
            cust_suggestR: [(v) => !!v || "cust_suggest is required"],
            cust_recommendR: [(v) => !!v || "cust_recommend is required"],
            cust_recommend_reasonR: [
                (v) => !!v || "cust_recommend_reason is required",
            ],
            RemarkR: [(v) => !!v || "Remark is required"],
            commentR: [(v) => !!v || "comment is required"],
            ProblemR: [(v) => !!v || "Problem is required"],
            CsoEmailR: [(v) => !!v || "CsoEmail is required"],
            hpc_level_reason: [],
            selectcso: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            remarkcustomer: "",
            remarkcustomerarray: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            dataicon: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            datadetail: [],
            datadetail1: {
                is_contact: "",

                skip_hpc: "",
                hpc_cust_suggest: "",
                hpc_cust_recommend: "",
                hpc_cust_reason: "",
                case: [
                    {
                        maincase_id: "",
                        email_in_cso: "",
                        problem_resolve: "",
                        problem_remark: "",
                        contact_again: "",
                        happy_level: "",
                        happy_reason: "",
                    },
                ],
            },
            remarkproblem: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            remark: "",
            selecticon: "",

            selectcustomer: "",
            selectproblem: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            selectcustomeragain: [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ],
            detailcase: [],
            active_tab: "",
            customer_sitename: "",
            customer_email: "",
            customer_name: "",
            customer_tel: "",
            datadetail: [],
            datashowdatastatus: "",
            tab: null,
            button: ["", "", "", ""],
            button_color: ["", "red", "amber darken-2", "green"],
            items1: [
                "ไม่ได้รับการแก้ไข",
                "Professional - ช่างไม่โทรนัดหมายล่วงหน้า",
                "Professional - ช่างมาไม่ตรงนัด ",
                "Professional - ช่างเลื่อนนัดลูกค้า",
                "Professional - ช่างแต่งกายไม่เรียบร้อย พูดจาไม่สุภาพ",
                "Professional - ช่างทำงานไม่เรียบร้อย รีบ หรือ ร้อนรน / ไม่ระมัดระวังตอนแกะเครื่องทำให้เครื่องมีรอย",
                "Professional - ช่างไม่ทำความสะอาดเครื่องให้หลังซ่อมเสร็จ",
                "Professional - ช่างไม่ใช้ที่รองเครื่องเวลาซ่อม Notebook",
                "Professional - ช่างเข้าช้า",
                "Communication skills - ช่างไม่ให้คำแนะนำ , ถามคำตอบคำ",
                "Technical knowledge - ช่างดูไม่น่าเชื่อถือ ซ่อมเครื่องไม่จบ ไม่ติดตามงาน",
                "Ease of access - Call center ติดต่อยาก รอสายนาน",
                "Speed of resolution - รออะไหล่นาน",
                "KCI - ไม่มีการอัพเดทสถานะงานจากส่วนกลาง ลค.ต้องโทรตามงานเองตลอด",
                "Overall - ราคาอะไหล่สูงเกินไป",
                "Overall - อะไหล่เสียง่ายเกินไป",
                "Overall - เครื่องเพิ่งซื้อ แต่ เสียง่าย (ใช้งานได้ไม่นานก็เสีย)",
            ],
            items2: [
                "ลค.ไม่ได้เจอกับช่างโดยตรง (ฝากให้คนอื่นรับเรื่องแทน)",
                "ลค.ยังไม่ได้เทสเครื่อง",
                "ลค.ไม่ค่อยอยากจะคุย หรือ ถามคำตอบคำ ไม่มี comment ใด ๆ",
                "ปัญหาเกี่ยวกับ 3rd party software ที่ไม่ได้อยู่ในความดูแลของ HP เช่น windows, ms office, ฯลฯ",
                "ลค.มีตามงานเคสอื่นด้วย",
            ],
            items3: [
                "Professional - ช่างแต่งกายเรียบร้อย พูดจาสุภาพ ช่างบริการดี ดูแลเอาใจใส่ และติดตามงานดี",
                "Professional - ช่างทำความสะอาดเครื่องให้หลังซ่อมเสร็จ",
                "Professional - ช่างตรงต่อเวลา",
                "Communication skills - ช่างอธิบายถึงสาเหตุของอาการเสียได้อย่างเข้าใจ",
                "Technical knowledge - ช่างแก้ไขปัญหาได้ตรงจุด ซ่อมจบไม่มีปัญหาเพิ่ม",
                "Speed of resolution - ระยะแก้ไขปัญหารวดเร็วทันใจ",
                "Overall - ดีอยู่แล้ว-ไม่มีอะไรต้องปรับปรุง",
            ],
            reason: [],
            dialog: false,
            dialogdetail: false,
            selectAllPending: false,
            datasummary: {
                Pending: "-",
                CannotContact: "-",
                NoEmail: "-",
                Recontact: "-",
                Premium: "-",
            },
            datasummary_default: {
                Pending: "-",
                CannotContact: "-",
                NoEmail: "-",
                Recontact: "-",
                Premium: "-",
            },

            num: 1,
            project: "",
            page: 1,
            page_total: 0,
            page_count: 0,

            selectproject: "",
            selectprojectsub: "",
            selectprojectid: "",
            data: [],
            datashowdata: [],
            dialog: false,
        }
    },

    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        chkPremium(casetitle) {
            return casetitle.indexOf("SF_Premium") > -1 ||
                casetitle.indexOf("SF_Student") > -1
                ? true
                : false
        },
        returncase(caseid) {
            this.$swal({
                title: "Retern case " + caseid + "?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.returncase1(caseid)
                } else {
                    // console.log("--no")
                }
            })
        },
        btnSelectAllPending() {
                if (this.selectAllPending == true) {
                    // เลือกทั้งหมด
                    this.checked = [];
                    for (let i = 0; i < this.datapending.length; i++) {
                        this.checked.push(this.datapending[i].maincase_id);
                    }
                } else {
                    // ยกเลิกทั้งหมด
                    this.checked = [];
                }
            },
        async returncase1(caseid) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/return-pending-hpc`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let { data } = await axios.post(
                    url,
                    {
                        case: caseid,
                    },
                    options
                )
                if (this.project != "all") {
                    this.showsummary(
                        this.project,
                        this.selecthappycallteam,
                        this.selectprojectid,
                        this.datashowdatastatus
                    )
                } else {
                    this.showsummary(
                        this.project,
                        "",
                        "",
                        this.datashowdatastatus
                    )
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        problem(dataloop) {
            if (this.selectproblem[dataloop] == "N") {
                this.selected(1, dataloop)
                this.hpc_level_reason[dataloop] = ["ไม่ได้รับการแก้ไข"]
                this.selectcustomeragain[dataloop] = ""
                this.hpc_covid_1 = ""
                this.hpc_covid_2 = ""
                this.hpc_covid_3 = ""
                this.hpc_covid_4 = ""
                this.hpc_covid_5 = ""
                this.hpc_covid_6 = ""
                this.hpc_covid_7 = ""
                this.hpc_covid_8 = ""
                this.hpc_covid_9 = ""
                this.hpc_covid_10 = ""
                this.cust_suggest = ""

                this.cust_recommend_reason = ""
                this.cust_recommend = ""
            } else {
                this.selected("", dataloop)
                this.hpc_level_reason[dataloop] = [""]
            }
        },

        btnselectallbooking() {
            if (this.selectallbooking == true) {
                for (let i = 0; i < this.databooking.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.databooking[i].maincase_id
                    )

                    if (index == -1) {
                        this.checkedbooking.push(
                            this.databooking[i].maincase_id
                        )
                    }
                }
            } else {
                for (let i = 0; i < this.databooking.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.databooking[i].maincase_id
                    )

                    this.checkedbooking.splice(index, 1)
                }
            }
        },
        btnselectalltoday() {
            if (this.selectalltoday == true) {
                for (let i = 0; i < this.datahpctoday.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.datahpctoday[i].maincase_id
                    )

                    if (index == -1) {
                        this.checkedbooking.push(
                            this.datahpctoday[i].maincase_id
                        )
                    }
                }
            } else {
                for (let i = 0; i < this.datahpctoday.length; i++) {
                    const index = this.checkedbooking.findIndex(
                        (button) => button === this.datahpctoday[i].maincase_id
                    )

                    this.checkedbooking.splice(index, 1)
                }
            }
        },
        async saveLog() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/savelog/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let { data } = await axios.post(url, this.log, options)
                this.detailcase.lognote = data.lognote

                setTimeout(() => {
                    this.log.log_note = ""
                }, 2000)
            } catch (error) {
                console.log(error.message)
            }
        },
        async saveallbooking() {
            // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/return`
            // console.log(item);
            var sent = {
                case: this.checkedbooking,
            }
            // console.log(sent);
            try {
                const { data } = await axios.post(url, sent, options)

                // this.mutateIsLoading();
                this.selectprojectsub = "all"
                this.getProject("all")
                this.showdata("all", "Pending")
                this.dialogbooking = false
            } catch (error) {
                console.log(error)
            }
        },
        viewallbooking() {
            this.checkedbooking = []
            this.dialogbooking = true
            this.selectallbooking = false
            this.selectalltoday = false
            this.showallbooking()
            this.showhpctoday()
        },
        async showallbooking() {
            // this.mutateIsLoading();
            this.databooking = []
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/happy-call/booking/` +
                `${this.selectproject}`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)
                // this.mutateIsLoading();
                this.checkedbooking = []

                var test = {
                    sumtitlebooking: "",
                }
                data.map((each) => {
                    test.sumtitlebooking += each.case_id
                    test.sumtitlebooking += "-"
                    test.sumtitlebooking += each.subcase
                    test.sumtitlebooking += each.site_name
                    test.sumtitlebooking += each.customer_tel
                    test.sumtitlebooking += each.created_date
                    test.sumtitlebooking += each.adminname
                    test.sumtitlebooking += "(HPC_Date: )"
                    test.sumtitlebooking += each.created_date

                    this.databooking.push(Object.assign({}, each, test))
                    test.sumtitlebooking = ""
                    // this.datadetail.push(Object.assign({}, each, ));
                })

                // console.log(this.databooking, "test");
            } catch (error) {
                // console.log(error);
            }
        },
        async showhpctoday() {
            // this.mutateIsLoading();
            this.datahpctoday = []
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/happy-call/hpc-today/` +
                `${this.selectproject}`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)
                // this.mutateIsLoading();
                this.checkedbooking = []
                var test = {
                    sumtitlebooking: "",
                }
                data.map((each) => {
                    test.sumtitlebooking += each.case_id
                    test.sumtitlebooking += "-"
                    test.sumtitlebooking += each.subcase
                    test.sumtitlebooking += each.site_name
                    test.sumtitlebooking += each.customer_tel
                    test.sumtitlebooking += each.created_date
                    test.sumtitlebooking += each.adminname
                    test.sumtitlebooking += "(HPC_Date: )"
                    test.sumtitlebooking += each.created_date

                    this.datahpctoday.push(Object.assign({}, each, test))
                    test.sumtitlebooking = ""
                    // this.datadetail.push(Object.assign({}, each, ));
                })
                // console.log(data);
            } catch (error) {
                console.log(error)
            }
        },
        btnexitdialog() {
            this.showdata(
                this.selectprojectid,
                this.datashowdatastatus,
                this.sortname,
                this.sortcondition,
                this.datapage.current_page
            )

            this.dialogdetail = false
        },
        closedialog() {
            this.showdata(
                this.selectprojectid,
                this.datashowdatastatus,
                this.sortname,
                this.sortcondition,
                this.datapage.current_page
            )
            this.searchtext = ""
            this.dialogdetail = false
        },
        //
        async savependinguc() {
            // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/pass-to-closecase`
            // console.log(item);
            var sent = {
                case: this.checked,
            }
            // console.log(sent);
            try {
                const { data } = await axios.post(url, sent, options)
                // this.mutateIsLoading();
                this.getAjax()
                this.dialog = false
            } catch (error) {
                console.log(error)
            }
        },
        checkboxselect(t, select) {
            if (select == "L" && this.buttonbad == true) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "L") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        if (index == -1) {
                            this.checked.push(this.datapending[i].maincase_id)
                        }
                    }
                }
            } else if (select == "L" && this.buttonbad == false) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "L") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        this.checked.splice(index, 1)
                    }
                }
            }
            if (select == "M" && this.buttonnormal == true) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "M") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        if (index == -1) {
                            this.checked.push(this.datapending[i].maincase_id)
                        }
                    }
                }
            } else if (select == "M" && this.buttonnormal == false) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "M") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        this.checked.splice(index, 1)
                    }
                }
            }
            if (select == "H" && this.buttongood == true) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "H") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        if (index == -1) {
                            this.checked.push(this.datapending[i].maincase_id)
                        }
                    }
                }
            } else if (select == "H" && this.buttongood == false) {
                for (let i = 0; i < t; i++) {
                    if (this.datapending[i].ce_customer_level == "H") {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        this.checked.splice(index, 1)
                    }
                }
            }
            if (select == "P" && this.buttonphone == true) {
                for (let i = 0; i < t; i++) {
                    if (
                        this.datapending[i].sub_status_name == "Clear by Phone"
                    ) {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        if (index == -1) {
                            this.checked.push(this.datapending[i].maincase_id)
                        }
                    }
                }
            } else if (select == "P" && this.buttonphone == false) {
                for (let i = 0; i < t; i++) {
                    if (
                        this.datapending[i].sub_status_name == "Clear by Phone"
                    ) {
                        const index = this.checked.findIndex(
                            (button) =>
                                button === this.datapending[i].maincase_id
                        )

                        this.checked.splice(index, 1)
                    }
                }
            }
        },
        viewallpending() {
            // this.mutateIsLoading();
            this.viewpendingtab = false
            this.dialog = true
            this.checked = []
            this.buttonbad = false
            this.buttonnormal = false
            this.buttongood = false
            this.buttonphone = false
            this.showallpending()
        },
        async showallpending() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/happy-call/view-all-pending/` +
                `${this.selectproject}`
            // console.log(url);
            try {
                const { data } = await axios.get(url, options)
                // this.mutateIsLoading();
                this.checked = []
                this.datapending = data
                this.viewpendingtab = true
                // console.log(this.datapending, "datapending");
            } catch (error) {
                // console.log(error);
            }
        },

        required(value) {
            if (value instanceof Array && value.length == 0) {
                return "Reason Customer is Required"
            }
            return !!value || " Reason Customer is Required"
        },
        requiredcomment(value) {
            if (value instanceof Array && value.length == 0) {
                return "Comment is Required"
            }
            return !!value || "Comment is Required"
        },
        // test(value) {
        //   if (value.length == 0) {
        //     return "Button is Required";
        //   }
        // },
        selectcus(tab, value) {
            if (value == "N") {
                for (let i = 0; i < tab; i++) {
                    this.selectcso[i] = ""
                    this.selectproblem[i] = ""
                    this.hpc_covid_1 = ""
                    this.hpc_covid_2 = ""
                    this.hpc_covid_3 = ""
                    this.hpc_covid_4 = ""
                    this.hpc_covid_5 = ""
                    this.hpc_covid_6 = ""
                    this.hpc_covid_7 = ""
                    this.hpc_covid_8 = ""
                    this.hpc_covid_9 = ""
                    this.hpc_covid_10 = ""
                    this.selectcustomeragain[i] = ""
                    this.remarkproblem[i] = ""
                    this.hpc_level_reason[i] = [""]
                    this.dataicon = [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ]
                    this.button = ["", "", "", ""]
                    this.selecticon = ""
                    this.colorselect[i] = [""]
                    this.skip = ""
                    this.cust_suggest = ""
                    this.cust_recommend = ""
                    this.cust_recommend_reason = ""
                    this.remarkcustomer = ""
                    this.remarkcustomerarray = [
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                    ]
                }
            } else if (value == "Y") {
            }
        },
        doCopy: function() {
            navigator.clipboard.writeText(this.text_closecase)
        },
        doCopyCase: function(t) {
            navigator.clipboard.writeText(
                this.datadetail[t].case_id + "-" + this.datadetail[t].subcase
            )
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },

        selected(api, i) {
            this.hpc_level_reason[i] = []

            var api1 = ""
            if (api == "1") {
                api1 = "L"
            } else if (api == "2") {
                api1 = "M"
            } else if (api == "3") {
                api1 = "H"
            }
            // this.button = ["", "", "", ""];
            // this.button[api] = this.button_color[api];
            this.colorselect[i] = api
            this.selecticon = api
            this.dataicon[i] = api1
        },

        async getDetail(e) {
            // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/casedetail/` + `${e}`
            try {
                const { data } = await axios.get(url, options)
                // this.mutateIsLoading();

                this.detailcase = data

                this.caseid = data.case_id
                // this.active_tab =
                this.customer_name = this.detailcase.customer_name

                this.customer_email = this.detailcase.customer_email

                // console.log(this.detailcase, "detailcase");
                if (parseInt(this.detailcase.subcase) > 0) {
                    this.active_tab = data.subcase - 1
                } else {
                    this.active_tab = 0
                }
            } catch (error) {
                console.log(error)
            }
        },
        remove(item, dataloop) {
            this.hpc_level_reason[dataloop].splice(
                this.hpc_level_reason[dataloop].indexOf(item),
                1
            )
            this.hpc_level_reason[dataloop] = this.hpc_level_reason[dataloop]
        },
        removecomment(item, dataloop) {
            this.remarkcustomer.splice(this.remarkcustomer.indexOf(item), 1)
        },
        getProject(project, happycallteam, projectid) {
            if (project != "all") {
                // alert(project);
                // alert(happycallteam);
                // alert(projectid);
                this.selectprojectsub = project
                this.selectprojectid = projectid
                this.selecthappycallteam = happycallteam
                this.showsummary(project, happycallteam, projectid)
            } else {
                this.selectprojectsub = "all"
                this.selectprojectid = "all"

                this.showsummary(project)
            }
        },
        async showsummary(project, happycallteam, projectid, defaultdata) {
            // alert(project);
            // alert(happycallteam);
            // alert(projectid);
            this.sorttatcondition = ""
            this.sortadmincondition = ""
            // // this.mutateIsLoading();
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.project = project
            this.datasummary = {
                Pending: "-",
                CannotContact: "-",
                NoEmail: "-",
                Recontact: "-",
            }
            if (project != "all") {
                this.datasummary = {
                    ...this.datasummary_default,
                }
                const url =
                    `${process.env.VUE_APP_ROOT_API}/api/happy-call/summary/` +
                    `${happycallteam}` +
                    "/" +
                    `${projectid}`

                try {
                    const { data } = await axios.get(url, options)
                    // // this.mutateIsLoading();
                    data.status.map((item) => {
                        if (item.status == "Pending") {
                            this.datasummary.Pending = item.num_rows
                        }
                        if (item.status == "Cannot Contact") {
                            this.datasummary.CannotContact = item.num_rows
                        }
                        if (item.status == "No Email") {
                            this.datasummary.NoEmail = item.num_rows
                        }
                        if (item.status == "Recontact") {
                            this.datasummary.Recontact = item.num_rows
                        }
                        if (item.status == "Premium") {
                            this.datasummary.Premium = item.num_rows
                        }
                    })
                    //  console.log(this.datasummary, "summarytest");
                    if (defaultdata != "" && defaultdata != undefined) {
                        // setTimeout(() => {
                        //   this.showdata(projectid, this.datashowdatastatus);
                        // }, 1500);
                        // alert(1);
                        this.showdata(projectid, this.datashowdatastatus)
                    } else {
                        // alert(2);
                        // setTimeout(() => {
                        //   this.showdata(projectid, "Pending");
                        // }, 1500);
                        // this.showdata(projectid, this.datashowdatastatus);
                        this.showdata(projectid, "Pending")
                    }
                    // console.log(data,'ffd');
                } catch (error) {
                    console.log(error)
                }
            } else {
                const url =
                    `${process.env.VUE_APP_ROOT_API}/api/happy-call/summary/` +
                    `${this.selectproject}` +
                    "/all"
                try {
                    const { data } = await axios.get(url, options)
                    // this.mutateIsLoading();
                    data.status.map((item) => {
                        if (item.status == "Pending") {
                            this.datasummary.Pending = item.num_rows
                        }
                        if (item.status == "Cannot Contact") {
                            this.datasummary.CannotContact = item.num_rows
                        }
                        if (item.status == "No Email") {
                            this.datasummary.NoEmail = item.num_rows
                        }
                        if (item.status == "Recontact") {
                            this.datasummary.Recontact = item.num_rows
                        }
                        if (item.status == "Premium") {
                            this.datasummary.Premium = item.num_rows
                        }
                    })
                    // console.log(this.datasummary, "summarytest");
                    this.showdata("all", "Pending")
                    if (defaultdata != "" && defaultdata != undefined) {
                        this.showdata("all", this.datashowdatastatus)
                    } else {
                        this.showdata("all", "Pending")
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async showdata(projectid, status, sortname, sortcondition, page) {
            // alert(projectid);
            // alert(status);
            this.casestatus = false
            // // this.mutateIsLoading();
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/view`
            // `${this.selectproject}` +
            // "/" +
            // `${projectid}` +
            // "/" +
            // `${status}`;
            if (sortname == null || sortname == undefined) {
                sortname = ""
            } else if (
                sortname == "tat" &&
                sortcondition != null &&
                sortcondition != undefined
            ) {
                this.sortname = sortname
                this.sortcondition = sortcondition
                this.sorttatcondition = sortcondition
                this.sortadmincondition = ""
            } else if (
                sortname == "adminname" &&
                sortcondition != null &&
                sortcondition != undefined
            ) {
                this.sortname = sortname
                this.sortcondition = sortcondition
                this.sortadmincondition = sortcondition
                this.sorttatcondition = ""
            }
            if (sortcondition == null || sortcondition == undefined) {
                sortcondition = ""
            }
            // console.log(url, "url");
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const { data } = await axios.post(
                    url,
                    {
                        searchtext: this.searchtext,
                        status: status,
                        happycall_team: this.selectproject,
                        show_name: projectid,
                        order_by: sortname,
                        order_condition: sortcondition,
                    },
                    options
                )
                // // this.mutateIsLoading();

                this.page_total = data.last_page
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
                this.datashowdata2 = data.data //22
                var checkbypass = {
                    bypass: "",
                }

                this.datashowdata = []
                this.datashowdata2.map((each) => {
                    if (
                        each.case_status_id.includes(8) == true ||
                        each.case_status_id.includes(9) == true
                    ) {
                        checkbypass.bypass = "bypass"
                    }

                    this.datashowdata.push(Object.assign({}, each, checkbypass))
                    checkbypass.bypass = ""
                })
                // console.log(this.datashowdata, "zzz");
                this.casestatus = true
                this.datapage = data
                this.datashowdatastatus = status
                this.projectidstatus = projectid
                // alert(this.datashowdatastatus);
                if (page != undefined && page != "" && page != null) {
                    this.datapage.current_page = page
                    this.get_it_page(
                        this.datapage.current_page,
                        this.selectprojectid
                    )
                }
                // console.log(data);
            } catch (error) {
                console.log(error)
            }
        },
        showdialogdetail(projectid, status, sitename, customername) {
            // alert(projectid);
            // alert(status);
            // alert(sitename);
            // alert(customername);
            this.mutateIsLoading()
            this.showdetail(projectid, status, sitename, customername)
        },
        async showdetail(projectid, status, sitename, customername) {
            this.hpc_covid_1 = ""
            this.hpc_covid_2 = ""
            this.hpc_covid_3 = ""
            this.hpc_covid_4 = ""
            this.hpc_covid_5 = ""
            this.hpc_covid_6 = ""
            this.hpc_covid_7 = ""
            this.hpc_covid_8 = ""
            this.hpc_covid_9 = ""
            this.hpc_covid_10 = ""

            this.skip = ""
            this.cust_suggest = ""
            this.cust_recommend = ""
            this.cust_recommend_reason = ""
            this.colorselect = []
            ;(this.selectproblem = [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ]),
                ((this.selectcso = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                ]),
                (this.remarkproblem = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                ])),
                (this.selectcustomer = "")
            this.remarkcustomer = ""
            this.remarkcustomerarray = [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ]
            this.hpc_level_reason = []
            this.button = ["", "", "", ""]
            this.dataicon = [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ]
            this.selecticon = ""
            this.tab = "0"
            this.cso.csoimage.images = []
            this.uefi.uefiimage.images = []
            ;(this.selectcustomeragain = [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
            ]),
                (this.datadetail = [])
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/happy-call/view-detail/` +
                `${this.selectproject}` +
                "/" +
                `${projectid}` +
                "/" +
                `${status}`
            // console.log(url, "zzz");

            var datahpc = {}
            try {
                const { data } = await axios.post(
                    url,
                    {
                        site_name: sitename,
                        customer_name: customername,
                    },
                    options
                )
                // console.log(data, "gfg");
                this.customer_tel = data.customer_tel
                this.mutateIsLoading()
                this.datacase.hpc_by = data.hpc_by
                this.datacase.hpc_status = data.hpc_status
                if (
                    this.datacase.hpc_status != "ok" &&
                    this.datacase.hpc_status != "limit"
                ) {
                    this.$swal(
                        "เคสนี้มีคน Book แล้ว",
                        "คน Book คือคุณ " + `${this.datacase.hpc_by}`,
                        "info"
                    )
                    this.dialogdetail = false
                    exit()
                } else if (this.datacase.hpc_status == "limit") {
                    this.$swal(
                        "Book Case เกินกำหนด กรุณาเคลียร์ Case ที่ Book ไว้ก่อน",
                        "",
                        "info"
                    )
                    this.dialogdetail = false
                    exit()
                }
                this.dialogdetail = true
                this.datadetail = []
                var test = {
                    problem_resolve: "",
                    problem_remark: "",
                    contact_again: "",
                    email_in_cso: "",
                }

                // console.log(data, "csoemail");
                data["cases"].map((each) => {
                    this.cso.images = []
                    this.uefi.images = []

                    // each.cso.map((res1) => {
                    //   if (res1.file_group == "cso") {
                    //     this.cso.csoimage.images.push(this.showpic1 + res1.file_id);
                    //   }
                    //   if (res1.file_group == "uefi") {
                    //     this.uefi.uefiimage.images.push(this.showpic1 + res1.file_id);
                    //   }
                    // });

                    this.datadetail.push(
                        Object.assign({}, each, test, this.cso, this.uefi)
                    )
                    // console.log(this.datadetail, "zsss");
                    // this.datadetail.push(Object.assign({}, each, ));
                })

                for (let i = 0; i < this.datadetail[0].cso.length; i++) {
                    if (this.datadetail[0].cso[i].file_group == "cso") {
                        this.datadetail[0].csoimage.images.push(
                            this.showpic1 + this.datadetail[0].cso[i].file_id
                        )
                    } else if (this.datadetail[0].cso[i].file_group == "uefi") {
                        this.datadetail[0].uefiimage.images.push(
                            this.showpic1 + this.datadetail[0].cso[i].file_id
                        )
                    }
                }
                // console.log(this.datadetail, "rr1");
                // this.datadetail.map((each) => {

                //         console.log(this.datadetail, "rr");
                //       });

                this.customer_sitename = this.datadetail[0].site_name
                this.getDetail(data.cases[0].maincase_id)
                // this.showdata(projectid, status);
                // this.showdata(this.project, "pending");
            } catch (error) {
                console.log(error)
            }
        },
        save(t) {
            // alert(this.skip);
            console.log(t, "- form data")
            var sent = []
            this.datadetail1 = {
                is_contact: "",
                skip_hpc: "",
                hpc_cust_suggest: "",
                hpc_cust_recommend: "",
                hpc_cust_reason: "",
                case: [],
            }
            for (let i = 0; i < t; i++) {
                if (
                    this.selectcso[i] == "" &&
                    this.selectcustomer != "N" &&
                    this.selectcustomer != "R" &&
                    this.selectproject != "BENCH" &&
                    this.selectproblem[i] != "T"
                ) {
                    this.$swal(
                        "กรุณากรอก CsoEmail และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Fill CsoEmail",
                        "info"
                    )
                    exit()
                }
                if (
                    this.selectcustomer != "N" &&
                    this.selectcustomer != "N/A" &&
                    this.selectcustomer != "R" &&
                    (this.colorselect[i] == "" ||
                        this.hpc_level_reason[i] == "") &&
                    this.selectproblem[i] != "T"
                ) {
                    this.$swal(
                        "กรุณาเลือกรูปยิ้ม / เหตุที่ลูกค้าพึ่งพอใจ และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Choose Icon / Reason Customer",
                        "info"
                    )
                    exit()
                }
                if (
                    this.selectcustomer != "N" &&
                    this.selectcustomer != "R" &&
                    this.selectcustomeragain[i] != "Y" &&
                    this.selectproblem[i] == ""
                ) {
                    this.$swal(
                        "กรุณากรอก Problem และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Fill Problem",
                        "info"
                    )
                    exit()
                }
                if (
                    this.selectproblem[i] == "" &&
                    this.selectcustomer != "N" &&
                    this.selectcustomer != "R" &&
                    this.selectcustomeragain[i] != "Y"
                ) {
                    this.$swal(
                        "กรุณากรอก CustomerAgain และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Fill CustomerAgain",
                        "info"
                    )
                    exit()
                }
                if (
                    (this.selectproblem[i] == "N" ||
                        this.selectcustomeragain[i] == "Y") &&
                    this.remarkproblem[i] == ""
                ) {
                    this.$swal(
                        "กรุณากรอก Reason และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Fill CustomerAgain",
                        "info"
                    )
                    exit()
                }

                if (
                    this.remarkcustomerarray[i] == "" &&
                    this.selectcustomer == "Y"
                ) {
                    this.$swal(
                        "กรุณากรอก Remark และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                        "Please Fill Remark",
                        "info"
                    )
                    exit()
                }

                // if (this.hpc_covid_1[i] == "" && this.selectcustomer == "Y") {
                //   this.$swal(
                //     "กรุณาเลือก hpc_covid_1 และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                //     "Please Choose hpc_covid_1",
                //     "info"
                //   );
                //   exit();
                // }

                // if (this.hpc_covid_2[i] == "" && this.selectcustomer == "Y") {
                //   this.$swal(
                //     "กรุณาเลือก hpc_covid_2 และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                //     "Please Choose hpc_covid_2",
                //     "info"
                //   );
                //   exit();
                // }

                // if (this.hpc_covid_3[i] == "" && this.selectcustomer == "Y") {
                //   this.$swal(
                //     "กรุณาเลือก hpc_covid_1 และกรุณาตรวจสอบคำถามให้ครบถ้วนใน case อื่นๆด้วยครับ",
                //     "Please Choose hpc_covid_3",
                //     "info"
                //   );
                //   exit();
                // }

                this.datadetail[i].problem_resolve = this.selectproblem[i]
                this.datadetail[i].problem_remark = this.remarkproblem[i]
                this.datadetail[i].contact_again = this.selectcustomeragain[i]
                this.datadetail[i].email_in_cso = this.selectcso[i]
                this.datadetail[i].happy_level = this.dataicon[i]
                this.datadetail[i].happy_reason = this.hpc_level_reason[i]

                this.datadetail[i].remark = this.remarkcustomerarray[i]

                if (
                    this.datadetail[i].contact_again == "N" &&
                    this.datadetail[i].problem_resolve == "Y"
                ) {
                    this.datadetail[i].problem_remark = ""
                }
                if (this.datadetail[i].problem_resolve == "T") {
                    this.datadetail[i].happy_reason = []
                    this.datadetail[i].happy_level = ""
                    this.datadetail[i].email_in_cso = ""
                }
            }
            this.datadetail1.skip_hpc = this.skip
            this.datadetail1.is_contact = this.selectcustomer

            this.datadetail1.hpc_covid_1 = this.hpc_covid_1
            this.datadetail1.hpc_covid_2 = this.hpc_covid_2
            this.datadetail1.hpc_covid_3 = this.hpc_covid_3
            this.datadetail1.ce = this.hpc_covid_4
            if (this.hpc_covid_4 == "Y") {
                this.datadetail1.ce_greeting = this.hpc_covid_5
                this.datadetail1.ce_personality = this.hpc_covid_6
                this.datadetail1.ce_resolve = this.hpc_covid_8
                this.datadetail1.ce_advice = this.hpc_covid_7
                this.datadetail1.ce_quality = this.hpc_covid_9
                this.datadetail1.appointment_time = this.hpc_covid_10
            } else {
                this.datadetail1.ce_greeting = ""
                this.datadetail1.ce_personality = ""
                this.datadetail1.ce_resolve = ""
                this.datadetail1.ce_advice = ""
                this.datadetail1.ce_quality = ""
                this.datadetail1.appointment_time = ""
            }
            this.datadetail1.hpc_premium_1 = this.hpc_premium_1
            this.datadetail1.hpc_premium_2 = this.hpc_premium_2
            this.datadetail1.hpc_premium_3 = this.hpc_premium_3
            this.datadetail1.hpc_cust_suggest = this.cust_suggest
            this.datadetail1.hpc_cust_recommend = this.cust_recommend
            this.datadetail1.hpc_cust_reason = this.cust_recommend_reason

            if (this.datadetail1.is_contact == "N") {
                this.datadetail1.skip_hpc = "Y"
            }
            // this.datadetail1.remark = this.remarkcustomer;

            this.datadetail.map((each) => {
                if (this.datadetail1.is_contact == "N") {
                    var sent = {
                        maincase_id: each.maincase_id,
                        email_in_cso: "",
                        problem_resolve: "",
                        problem_remark: "",
                        contact_again: "",
                        happy_level: "",
                        happy_reason: "",

                        remark: "โทรไม่ติดเกิน 3 ครั้ง",
                    }
                } else if (this.datadetail1.is_contact == "R") {
                    var sent = {
                        maincase_id: each.maincase_id,
                        email_in_cso: "",
                        problem_resolve: "",
                        problem_remark: "",
                        contact_again: "",
                        happy_level: "",
                        happy_reason: "",

                        remark: this.remarkcustomer,
                    }
                } else {
                    var sent = {
                        maincase_id: each.maincase_id,
                        email_in_cso: each.email_in_cso,
                        problem_resolve: each.problem_resolve,
                        problem_remark: each.problem_remark,
                        contact_again: each.contact_again,
                        happy_level: each.happy_level,
                        happy_reason: each.happy_reason,

                        remark: each.remark,
                    }
                }
                this.datadetail1.case.push(sent)
            })
            // console.log(this.datadetail1, "-data save")
            this.sendAjax(this.datadetail1)

            this.dialogdetail = false
        },
        async sendAjax(item) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/save`
            // console.log(item);
            try {
                const { data } = await axios.post(url, item, options)
                // console.log(data)
            } catch (error) {
                console.log(error)
            }
            // this.close();
            if (this.project != "all") {
                this.showsummary(
                    this.project,
                    this.selecthappycallteam,
                    this.selectprojectid,
                    this.datashowdatastatus
                )
            } else {
                this.showsummary(this.project, "", "", this.datashowdatastatus)
            }
            this.searchtext = ""
        },
        async getAjax(val) {
            if (val == 1) {
                this.mutateIsLoading()
            }
            this.statustab = false

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/check-team`
            try {
                const { data } = await axios.get(url, options)
                this.data = data
                if (val == 1) {
                    this.mutateIsLoading()
                }
                this.statustab = true

                // console.log(this.data, "jjjj")
                this.selectproject = this.data.happycall_team
                if (this.selectproject == "ONSITE") {
                    this.getProject("all")
                } else if (this.selectproject == "BENCH") {
                    this.getProject("BKK", "BENCH", "BKK")
                } else if (this.selectproject == "BENCH") {
                    this.getProject("UC", "BENCH", "UC")
                }
                // console.log(data);
            } catch (error) {
                console.log(error)
            }
        },

        async back() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage.prev_page_url
            let { data } = await axios.post(
                url,
                {
                    searchtext: this.searchtext,
                    status: this.datashowdatastatus,
                    happycall_team: this.selectproject,
                    show_name: this.selectprojectid,
                    order_by: this.sortname,
                    order_condition: this.sortcondition,
                },
                options
            )

            this.datashowdata2 = data.data //22
            var checkbypass = {
                bypass: "",
            }

            this.datashowdata = []
            this.datashowdata2.map((each) => {
                if (
                    each.case_status_id.includes(8) == true ||
                    each.case_status_id.includes(9) == true
                ) {
                    checkbypass.bypass = "bypass"
                }

                this.datashowdata.push(Object.assign({}, each, checkbypass))
                checkbypass.bypass = ""
            })
            this.datapage = data
        },
        async next() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.datapage.next_page_url
            let { data } = await axios.post(
                url,
                {
                    searchtext: this.searchtext,
                    status: this.datashowdatastatus,
                    happycall_team: this.selectproject,
                    show_name: this.selectprojectid,
                    order_by: this.sortname,
                    order_condition: this.sortcondition,
                },
                options
            )
            this.datashowdata2 = data.data //22
            var checkbypass = {
                bypass: "",
            }

            this.datashowdata = []
            this.datashowdata2.map((each) => {
                if (
                    each.case_status_id.includes(8) == true ||
                    each.case_status_id.includes(9) == true
                ) {
                    checkbypass.bypass = "bypass"
                }

                this.datashowdata.push(Object.assign({}, each, checkbypass))
                checkbypass.bypass = ""
            })

            this.datapage = data
        },
        async get_it_page(num, project1) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/happy-call/view` +
                    // `${this.selectproject}` +
                    // "/" +
                    // project1 +
                    // "/" +
                    // `${this.datashowdatastatus}` +
                    "/?page=" +
                    num
                if (this.sortname == undefined || this.sortname == null) {
                    this.sortname = ""
                }
                if (this.sortname == undefined || this.sortname == null) {
                    this.sortname = ""
                }
                let { data } = await axios.post(
                    url,
                    {
                        searchtext: this.searchtext,
                        status: this.datashowdatastatus,
                        happycall_team: this.selectproject,
                        show_name: this.selectprojectid,
                        order_by: this.sortname,
                        order_condition: this.sortcondition,
                    },
                    options
                )
                // console.log(url);
                this.datashowdata2 = data.data //22
                var checkbypass = {
                    bypass: "",
                }

                this.datashowdata = []
                this.datashowdata2.map((each) => {
                    if (
                        each.case_status_id.includes(8) == true ||
                        each.case_status_id.includes(9) == true
                    ) {
                        checkbypass.bypass = "bypass"
                    }

                    this.datashowdata.push(Object.assign({}, each, checkbypass))
                    checkbypass.bypass = ""
                })
                this.datapage = data
            }
        },
        async getall(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/happy-call/view/` +
                    // `${this.selectproject}` +
                    // "/" +
                    // "all" +
                    // "/" +
                    // `${this.datashowdatastatus}` +
                    "/?page=" +
                    num

                let { data } = await axios.post(
                    url,
                    {
                        searchtext: this.searchtext,
                        status: this.datashowdatastatus,
                        happycall_team: this.selectproject,
                        show_name: this.selectprojectid,
                        order_by: this.sortname,
                        order_condition: this.sortcondition,
                    },
                    options
                )
                // console.log(url);
                this.datashowdata2 = data.data //22
                var checkbypass = {
                    bypass: "",
                }

                this.datashowdata = []
                this.datashowdata2.map((each) => {
                    if (
                        each.case_status_id.includes(8) == true ||
                        each.case_status_id.includes(9) == true
                    ) {
                        checkbypass.bypass = "bypass"
                    }

                    this.datashowdata.push(Object.assign({}, each, checkbypass))
                    checkbypass.bypass = ""
                })
                this.datapage = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.datapage.current_page <= 4) {
                    return this.datapage.current_page === n ? "primary" : ""
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.datapage.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.datapage.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page == this.datapage.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else if (this.datapage.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.datapage.last_page - 1
                } else if (
                    this.datapage.current_page ==
                    this.datapage.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.datapage.last_page - 3
                    chk5 = this.datapage.last_page - 2
                    chk6 = this.datapage.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.datapage.current_page - 1
                    chk4 = this.datapage.current_page
                    chk5 = this.datapage.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.datapage.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
    },
}
</script>

<style scoped>
.v-input__slot {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: inherit;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-left: 15px;
    min-height: inherit;
    position: relative;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

.v-tabs-bar.primary .v-tab,
.v-tabs-bar.primary .v-tabs-slider,
.v-tabs-bar.secondary .v-tab,
.v-tabs-bar.secondary .v-tabs-slider,
.v-tabs-bar.accent .v-tab,
.v-tabs-bar.accent .v-tabs-slider,
.v-tabs-bar.success .v-tab,
.v-tabs-bar.success .v-tabs-slider,
.v-tabs-bar.error .v-tab,
.v-tabs-bar.error .v-tabs-slider,
.v-tabs-bar.warning .v-tab,
.v-tabs-bar.warning .v-tabs-slider,
.v-tabs-bar.info .v-tab,
.v-tabs-bar.info .v-tabs-slider {
    color: rgb(36, 44, 153);
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 0px 0px 0px 0px;
}
</style>
<style scoped>
@media screen and (min-width: 1024px) {
    .valuecaseID {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 40%;
        flex: 0 0 40%;
        max-width: 40%;
        display: block;
    }

    .caseID {
        color: black;
        font-weight: bold;
        width: 200px;
        display: block;
    }

    /* .v-application .orange.accent-3 {
        height: 120px;
    }
    .v-application .cyan.lighten-1 {
        height: 120px;
    }
    .v-application .red.darken-1 {
        height: 120px;
    }
    .v-application .teal.lighten-1 {
        height: 120px;
    } */
}

.fontglow {
    color: #edf5f7;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}

.hover {
    background: blue;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
    font-size: 50px;
}

.hover1 {
    font-size: 50px;
    background: blue;
}
</style>
